// Do not edit manually!
// This file is automatically generated by importWebIconsFromFigma.ts script.

import type {SvgAsset} from '*.svg';

import addLinkOutlined16 from './add-link/add-link-outlined-16.svg';
import addReactionOutlined16 from './add-reaction/add-reaction-outlined-16.svg';
import adjustToneOutlined12 from './adjust-tone/adjust-tone-outlined-12.svg';
import adjustToneOutlined16 from './adjust-tone/adjust-tone-outlined-16.svg';
import agentFilled16 from './agent/agent-filled-16.svg';
import agentOutlined16 from './agent/agent-outlined-16.svg';
import aiGradient16 from './ai/ai-gradient-16.svg';
import aiGradient20 from './ai/ai-gradient-20.svg';
import aiGradient32 from './ai/ai-gradient-32.svg';
import aiSolid16 from './ai/ai-solid-16.svg';
import aiAgentFilled12 from './ai-agent/ai-agent-filled-12.svg';
import aiAgentFilled16 from './ai-agent/ai-agent-filled-16.svg';
import aiAgentOutlined16 from './ai-agent/ai-agent-outlined-16.svg';
import aiComposeOutlined12 from './ai-compose/ai-compose-outlined-12.svg';
import aiComposeOutlined16 from './ai-compose/ai-compose-outlined-16.svg';
import aiComposeOutlined20 from './ai-compose/ai-compose-outlined-20.svg';
import aiConnectorsFilled12 from './ai-connectors/ai-connectors-filled-12.svg';
import aiConnectorsFilled16 from './ai-connectors/ai-connectors-filled-16.svg';
import aiConnectorsFilled20 from './ai-connectors/ai-connectors-filled-20.svg';
import aiConnectorsOutlined12 from './ai-connectors/ai-connectors-outlined-12.svg';
import aiConnectorsOutlined16 from './ai-connectors/ai-connectors-outlined-16.svg';
import aiConnectorsOutlined20 from './ai-connectors/ai-connectors-outlined-20.svg';
import aiSolidFilled16 from './ai-solid/ai-solid-filled-16.svg';
import aiSolidOutlined16 from './ai-solid/ai-solid-outlined-16.svg';
import aiSummaryOutlined16 from './ai-summary/ai-summary-outlined-16.svg';
import alarmClockFilled12 from './alarm-clock/alarm-clock-filled-12.svg';
import alarmClockFilled16 from './alarm-clock/alarm-clock-filled-16.svg';
import alarmClockFilled20 from './alarm-clock/alarm-clock-filled-20.svg';
import alarmClockOutlined12 from './alarm-clock/alarm-clock-outlined-12.svg';
import alarmClockOutlined16 from './alarm-clock/alarm-clock-outlined-16.svg';
import alarmClockOutlined20 from './alarm-clock/alarm-clock-outlined-20.svg';
import alertCircleFilled12 from './alert-circle/alert-circle-filled-12.svg';
import alertCircleFilled16 from './alert-circle/alert-circle-filled-16.svg';
import alertCircleFilled20 from './alert-circle/alert-circle-filled-20.svg';
import alertCircleOutlined12 from './alert-circle/alert-circle-outlined-12.svg';
import alertCircleOutlined16 from './alert-circle/alert-circle-outlined-16.svg';
import alertCircleOutlined20 from './alert-circle/alert-circle-outlined-20.svg';
import alertHexagonFilled12 from './alert-hexagon/alert-hexagon-filled-12.svg';
import alertHexagonFilled16 from './alert-hexagon/alert-hexagon-filled-16.svg';
import alertHexagonFilled20 from './alert-hexagon/alert-hexagon-filled-20.svg';
import alertHexagonOutlined12 from './alert-hexagon/alert-hexagon-outlined-12.svg';
import alertHexagonOutlined16 from './alert-hexagon/alert-hexagon-outlined-16.svg';
import alertHexagonOutlined20 from './alert-hexagon/alert-hexagon-outlined-20.svg';
import alertSquareOutlined16 from './alert-square/alert-square-outlined-16.svg';
import alertTriangleFilled12 from './alert-triangle/alert-triangle-filled-12.svg';
import alertTriangleFilled16 from './alert-triangle/alert-triangle-filled-16.svg';
import alertTriangleFilled20 from './alert-triangle/alert-triangle-filled-20.svg';
import alertTriangleOutlined12 from './alert-triangle/alert-triangle-outlined-12.svg';
import alertTriangleOutlined16 from './alert-triangle/alert-triangle-outlined-16.svg';
import alertTriangleOutlined20 from './alert-triangle/alert-triangle-outlined-20.svg';
import alignLeftOutlined12 from './align-left/align-left-outlined-12.svg';
import alignLeftOutlined16 from './align-left/align-left-outlined-16.svg';
import alignLeftOutlined20 from './align-left/align-left-outlined-20.svg';
import alignVerticalCenterOutlined16 from './align-vertical-center/align-vertical-center-outlined-16.svg';
import archiveFilled12 from './archive/archive-filled-12.svg';
import archiveFilled16 from './archive/archive-filled-16.svg';
import archiveFilled20 from './archive/archive-filled-20.svg';
import archiveOutlined12 from './archive/archive-outlined-12.svg';
import archiveOutlined16 from './archive/archive-outlined-16.svg';
import archiveOutlined20 from './archive/archive-outlined-20.svg';
import archiveOffFilled12 from './archive-off/archive-off-filled-12.svg';
import archiveOffFilled16 from './archive-off/archive-off-filled-16.svg';
import archiveOffFilled20 from './archive-off/archive-off-filled-20.svg';
import archiveOffOutlined12 from './archive-off/archive-off-outlined-12.svg';
import arrowBlockRightFilled12 from './arrow-block-right/arrow-block-right-filled-12.svg';
import arrowBlockRightFilled16 from './arrow-block-right/arrow-block-right-filled-16.svg';
import arrowBlockRightFilled20 from './arrow-block-right/arrow-block-right-filled-20.svg';
import arrowBlockRightOutlined12 from './arrow-block-right/arrow-block-right-outlined-12.svg';
import arrowBlockRightOutlined16 from './arrow-block-right/arrow-block-right-outlined-16.svg';
import arrowBlockRightOutlined20 from './arrow-block-right/arrow-block-right-outlined-20.svg';
import arrowCircleBrokenRightFilled16 from './arrow-circle-broken-right/arrow-circle-broken-right-filled-16.svg';
import arrowNarrowDownFilled16 from './arrow-narrow-down/arrow-narrow-down-filled-16.svg';
import arrowNarrowDownOutlined12 from './arrow-narrow-down/arrow-narrow-down-outlined-12.svg';
import arrowNarrowDownOutlined16 from './arrow-narrow-down/arrow-narrow-down-outlined-16.svg';
import arrowNarrowDownRightOutlined16 from './arrow-narrow-down-right/arrow-narrow-down-right-outlined-16.svg';
import arrowNarrowLeftFilled16 from './arrow-narrow-left/arrow-narrow-left-filled-16.svg';
import arrowNarrowLeftOutlined16 from './arrow-narrow-left/arrow-narrow-left-outlined-16.svg';
import arrowNarrowRightFilled12 from './arrow-narrow-right/arrow-narrow-right-filled-12.svg';
import arrowNarrowRightFilled16 from './arrow-narrow-right/arrow-narrow-right-filled-16.svg';
import arrowNarrowRightFilled20 from './arrow-narrow-right/arrow-narrow-right-filled-20.svg';
import arrowNarrowRightOutlined12 from './arrow-narrow-right/arrow-narrow-right-outlined-12.svg';
import arrowNarrowRightOutlined16 from './arrow-narrow-right/arrow-narrow-right-outlined-16.svg';
import arrowNarrowRightOutlined20 from './arrow-narrow-right/arrow-narrow-right-outlined-20.svg';
import arrowNarrowUpFilled16 from './arrow-narrow-up/arrow-narrow-up-filled-16.svg';
import arrowNarrowUpOutlined12 from './arrow-narrow-up/arrow-narrow-up-outlined-12.svg';
import arrowNarrowUpOutlined16 from './arrow-narrow-up/arrow-narrow-up-outlined-16.svg';
import arrowNarrowUpOutlined20 from './arrow-narrow-up/arrow-narrow-up-outlined-20.svg';
import arrowNarrowUpRightFilled20 from './arrow-narrow-up-right/arrow-narrow-up-right-filled-20.svg';
import arrowNarrowUpRightOutlined12 from './arrow-narrow-up-right/arrow-narrow-up-right-outlined-12.svg';
import arrowNarrowUpRightOutlined16 from './arrow-narrow-up-right/arrow-narrow-up-right-outlined-16.svg';
import arrowNarrowUpRightOutlined20 from './arrow-narrow-up-right/arrow-narrow-up-right-outlined-20.svg';
import atSignFilled16 from './at-sign/at-sign-filled-16.svg';
import atSignOutlined12 from './at-sign/at-sign-outlined-12.svg';
import atSignOutlined16 from './at-sign/at-sign-outlined-16.svg';
import atSignOutlined20 from './at-sign/at-sign-outlined-20.svg';
import auditLogFilled16 from './audit-log/audit-log-filled-16.svg';
import auditLogOutlined12 from './audit-log/audit-log-outlined-12.svg';
import auditLogOutlined16 from './audit-log/audit-log-outlined-16.svg';
import auditLogOutlined20 from './audit-log/audit-log-outlined-20.svg';
import autopilotFilled16 from './autopilot/autopilot-filled-16.svg';
import autopilotFilled20 from './autopilot/autopilot-filled-20.svg';
import autopilotOutlined12 from './autopilot/autopilot-outlined-12.svg';
import autopilotOutlined16 from './autopilot/autopilot-outlined-16.svg';
import autopilotOutlined20 from './autopilot/autopilot-outlined-20.svg';
import barChart01Filled16 from './bar-chart-01/bar-chart-01-filled-16.svg';
import barChart01Filled20 from './bar-chart-01/bar-chart-01-filled-20.svg';
import barChart01Outlined16 from './bar-chart-01/bar-chart-01-outlined-16.svg';
import barChart01Outlined20 from './bar-chart-01/bar-chart-01-outlined-20.svg';
import barChart10Filled16 from './bar-chart-10/bar-chart-10-filled-16.svg';
import barChart10Outlined16 from './bar-chart-10/bar-chart-10-outlined-16.svg';
import barChart10Outlined20 from './bar-chart-10/bar-chart-10-outlined-20.svg';
import beakerFilled12 from './beaker/beaker-filled-12.svg';
import beakerFilled16 from './beaker/beaker-filled-16.svg';
import beakerFilled20 from './beaker/beaker-filled-20.svg';
import beakerOutlined12 from './beaker/beaker-outlined-12.svg';
import beakerOutlined16 from './beaker/beaker-outlined-16.svg';
import beakerOutlined20 from './beaker/beaker-outlined-20.svg';
import bell01Filled12 from './bell-01/bell-01-filled-12.svg';
import bell01Filled16 from './bell-01/bell-01-filled-16.svg';
import bell01Filled20 from './bell-01/bell-01-filled-20.svg';
import bell01Outlined12 from './bell-01/bell-01-outlined-12.svg';
import bell01Outlined16 from './bell-01/bell-01-outlined-16.svg';
import bell01Outlined20 from './bell-01/bell-01-outlined-20.svg';
import bellOff01Filled16 from './bell-off-01/bell-off-01-filled-16.svg';
import bellOff01Filled20 from './bell-off-01/bell-off-01-filled-20.svg';
import bellOff01Outlined12 from './bell-off-01/bell-off-01-outlined-12.svg';
import bellOff01Outlined16 from './bell-off-01/bell-off-01-outlined-16.svg';
import bellOff01Outlined20 from './bell-off-01/bell-off-01-outlined-20.svg';
import bold01Outlined16 from './bold-01/bold-01-outlined-16.svg';
import bold01Outlined20 from './bold-01/bold-01-outlined-20.svg';
import bookClosedOutlined16 from './book-closed/book-closed-outlined-16.svg';
import bookClosedOutlined20 from './book-closed/book-closed-outlined-20.svg';
import bookOpen01Filled16 from './book-open-01/book-open-01-filled-16.svg';
import bookOpen01Filled20 from './book-open-01/book-open-01-filled-20.svg';
import bookOpen01Outlined12 from './book-open-01/book-open-01-outlined-12.svg';
import bookOpen01Outlined16 from './book-open-01/book-open-01-outlined-16.svg';
import bookOpen01Outlined20 from './book-open-01/book-open-01-outlined-20.svg';
import bracketsEllipsesFilled16 from './brackets-ellipses/brackets-ellipses-filled-16.svg';
import bracketsEllipsesFilled20 from './brackets-ellipses/brackets-ellipses-filled-20.svg';
import bracketsEllipsesOutlined12 from './brackets-ellipses/brackets-ellipses-outlined-12.svg';
import bracketsEllipsesOutlined16 from './brackets-ellipses/brackets-ellipses-outlined-16.svg';
import bracketsEllipsesOutlined20 from './brackets-ellipses/brackets-ellipses-outlined-20.svg';
import branchingRuleFilled16 from './branching-rule/branching-rule-filled-16.svg';
import branchingRuleFilled20 from './branching-rule/branching-rule-filled-20.svg';
import branchingRuleOutlined16 from './branching-rule/branching-rule-outlined-16.svg';
import briefcase01Filled12 from './briefcase-01/briefcase-01-filled-12.svg';
import briefcase01Filled16 from './briefcase-01/briefcase-01-filled-16.svg';
import briefcase01Filled20 from './briefcase-01/briefcase-01-filled-20.svg';
import briefcase01Outlined12 from './briefcase-01/briefcase-01-outlined-12.svg';
import briefcase01Outlined16 from './briefcase-01/briefcase-01-outlined-16.svg';
import briefcase01Outlined20 from './briefcase-01/briefcase-01-outlined-20.svg';
import briefcase01PlusOutlined16 from './briefcase-01-plus/briefcase-01-plus-outlined-16.svg';
import building05Filled16 from './building-05/building-05-filled-16.svg';
import building05Filled20 from './building-05/building-05-filled-20.svg';
import building05Outlined16 from './building-05/building-05-outlined-16.svg';
import building05Outlined20 from './building-05/building-05-outlined-20.svg';
import businessHoursFilled20 from './business-hours/business-hours-filled-20.svg';
import businessHoursOutlined16 from './business-hours/business-hours-outlined-16.svg';
import calendarFilled12 from './calendar/calendar-filled-12.svg';
import calendarFilled16 from './calendar/calendar-filled-16.svg';
import calendarFilled20 from './calendar/calendar-filled-20.svg';
import calendarOutlined12 from './calendar/calendar-outlined-12.svg';
import calendarOutlined16 from './calendar/calendar-outlined-16.svg';
import calendarOutlined20 from './calendar/calendar-outlined-20.svg';
import calendarCheck02Filled16 from './calendar-check-02/calendar-check-02-filled-16.svg';
import calendarCheck02Filled20 from './calendar-check-02/calendar-check-02-filled-20.svg';
import calendarCheck02Outlined16 from './calendar-check-02/calendar-check-02-outlined-16.svg';
import calendarCheck02Outlined20 from './calendar-check-02/calendar-check-02-outlined-20.svg';
import calendarPlus02Outlined20 from './calendar-plus-02/calendar-plus-02-outlined-20.svg';
import caretCollapseOutlined12 from './caret-collapse/caret-collapse-outlined-12.svg';
import caretCollapseOutlined16 from './caret-collapse/caret-collapse-outlined-16.svg';
import caretExpandOutlined12 from './caret-expand/caret-expand-outlined-12.svg';
import caretExpandOutlined16 from './caret-expand/caret-expand-outlined-16.svg';
import chatFilled12 from './chat/chat-filled-12.svg';
import chatFilled16 from './chat/chat-filled-16.svg';
import chatFilled20 from './chat/chat-filled-20.svg';
import chatOutlined12 from './chat/chat-outlined-12.svg';
import chatOutlined16 from './chat/chat-outlined-16.svg';
import chatOutlined20 from './chat/chat-outlined-20.svg';
import chatEndedActivityOutlined12 from './chat-ended-activity/chat-ended-activity-outlined-12.svg';
import checkOutlined12 from './check/check-outlined-12.svg';
import checkOutlined16 from './check/check-outlined-16.svg';
import checkOutlined20 from './check/check-outlined-20.svg';
import checkCircleFilled12 from './check-circle/check-circle-filled-12.svg';
import checkCircleFilled16 from './check-circle/check-circle-filled-16.svg';
import checkCircleFilled20 from './check-circle/check-circle-filled-20.svg';
import checkCircleOutlined12 from './check-circle/check-circle-outlined-12.svg';
import checkCircleOutlined16 from './check-circle/check-circle-outlined-16.svg';
import checkCircleOutlined20 from './check-circle/check-circle-outlined-20.svg';
import checkVerified02Filled16 from './check-verified-02/check-verified-02-filled-16.svg';
import checkVerified02Filled20 from './check-verified-02/check-verified-02-filled-20.svg';
import checkVerified02Outlined16 from './check-verified-02/check-verified-02-outlined-16.svg';
import chevronDownOutlined12 from './chevron-down/chevron-down-outlined-12.svg';
import chevronDownOutlined16 from './chevron-down/chevron-down-outlined-16.svg';
import chevronDownOutlined20 from './chevron-down/chevron-down-outlined-20.svg';
import chevronLeftOutlined16 from './chevron-left/chevron-left-outlined-16.svg';
import chevronLeftOutlined20 from './chevron-left/chevron-left-outlined-20.svg';
import chevronRightOutlined12 from './chevron-right/chevron-right-outlined-12.svg';
import chevronRightOutlined16 from './chevron-right/chevron-right-outlined-16.svg';
import chevronRightOutlined20 from './chevron-right/chevron-right-outlined-20.svg';
import chevronUpOutlined12 from './chevron-up/chevron-up-outlined-12.svg';
import chevronUpOutlined16 from './chevron-up/chevron-up-outlined-16.svg';
import chevronUpOutlined20 from './chevron-up/chevron-up-outlined-20.svg';
import circleFilled16 from './circle/circle-filled-16.svg';
import clockFilled12 from './clock/clock-filled-12.svg';
import clockFilled16 from './clock/clock-filled-16.svg';
import clockFilled20 from './clock/clock-filled-20.svg';
import clockOutlined12 from './clock/clock-outlined-12.svg';
import clockOutlined16 from './clock/clock-outlined-16.svg';
import clockOutlined20 from './clock/clock-outlined-20.svg';
import clockCheckOutlined16 from './clock-check/clock-check-outlined-16.svg';
import clockPlayOutlined12 from './clock-play/clock-play-outlined-12.svg';
import clockPlayOutlined16 from './clock-play/clock-play-outlined-16.svg';
import clockPlayOutlined20 from './clock-play/clock-play-outlined-20.svg';
import clockPlayOutlined24 from './clock-play/clock-play-outlined-24.svg';
import clockRewindOutlined16 from './clock-rewind/clock-rewind-outlined-16.svg';
import clockRewindOutlined20 from './clock-rewind/clock-rewind-outlined-20.svg';
import clockSnoozeFilled16 from './clock-snooze/clock-snooze-filled-16.svg';
import clockSnoozeOutlined16 from './clock-snooze/clock-snooze-outlined-16.svg';
import clockSnoozeOutlined20 from './clock-snooze/clock-snooze-outlined-20.svg';
import cloudOffFilled16 from './cloud-off/cloud-off-filled-16.svg';
import cloudOffFilled20 from './cloud-off/cloud-off-filled-20.svg';
import code01Filled16 from './code-01/code-01-filled-16.svg';
import code01Outlined12 from './code-01/code-01-outlined-12.svg';
import code01Outlined16 from './code-01/code-01-outlined-16.svg';
import code01Outlined20 from './code-01/code-01-outlined-20.svg';
import columns03Filled12 from './columns-03/columns-03-filled-12.svg';
import columns03Filled16 from './columns-03/columns-03-filled-16.svg';
import columns03Filled20 from './columns-03/columns-03-filled-20.svg';
import columns03Outlined12 from './columns-03/columns-03-outlined-12.svg';
import columns03Outlined16 from './columns-03/columns-03-outlined-16.svg';
import columns03Outlined20 from './columns-03/columns-03-outlined-20.svg';
import connectorsFilled12 from './connectors/connectors-filled-12.svg';
import connectorsFilled16 from './connectors/connectors-filled-16.svg';
import connectorsFilled20 from './connectors/connectors-filled-20.svg';
import connectorsOutlined12 from './connectors/connectors-outlined-12.svg';
import connectorsOutlined16 from './connectors/connectors-outlined-16.svg';
import connectorsOutlined20 from './connectors/connectors-outlined-20.svg';
import contactAutoFilled12 from './contact-auto/contact-auto-filled-12.svg';
import contactAutoFilled16 from './contact-auto/contact-auto-filled-16.svg';
import contactAutoOutlined16 from './contact-auto/contact-auto-outlined-16.svg';
import contrast02Filled12 from './contrast-02/contrast-02-filled-12.svg';
import contrast02Outlined12 from './contrast-02/contrast-02-outlined-12.svg';
import contrast02Outlined16 from './contrast-02/contrast-02-outlined-16.svg';
import contrast02Outlined20 from './contrast-02/contrast-02-outlined-20.svg';
import conversationOutlined12 from './conversation/conversation-outlined-12.svg';
import conversationOutlined16 from './conversation/conversation-outlined-16.svg';
import conversationSearchOutlined20 from './conversation-search/conversation-search-outlined-20.svg';
import copilotFilled20 from './copilot/copilot-filled-20.svg';
import copilotOutlined16 from './copilot/copilot-outlined-16.svg';
import copy06Outlined12 from './copy-06/copy-06-outlined-12.svg';
import copy06Outlined16 from './copy-06/copy-06-outlined-16.svg';
import copyFileFilled16 from './copy-file/copy-file-filled-16.svg';
import copyFileOutlined20 from './copy-file/copy-file-outlined-20.svg';
import cornerDownRightOutlined12 from './corner-down-right/corner-down-right-outlined-12.svg';
import cornerDownRightOutlined16 from './corner-down-right/corner-down-right-outlined-16.svg';
import cornerDownRightOutlined20 from './corner-down-right/corner-down-right-outlined-20.svg';
import cornerUpLeftFilled16 from './corner-up-left/corner-up-left-filled-16.svg';
import cornerUpLeftFilled20 from './corner-up-left/corner-up-left-filled-20.svg';
import cornerUpLeftOutlined12 from './corner-up-left/corner-up-left-outlined-12.svg';
import cornerUpLeftOutlined16 from './corner-up-left/corner-up-left-outlined-16.svg';
import cornerUpLeftOutlined20 from './corner-up-left/corner-up-left-outlined-20.svg';
import cornerUpLeftDoubleOutlined16 from './corner-up-left-double/corner-up-left-double-outlined-16.svg';
import cornerUpLeftDoubleOutlined20 from './corner-up-left-double/corner-up-left-double-outlined-20.svg';
import cornerUpRightFilled20 from './corner-up-right/corner-up-right-filled-20.svg';
import cornerUpRightOutlined16 from './corner-up-right/corner-up-right-outlined-16.svg';
import cornerUpRightOutlined20 from './corner-up-right/corner-up-right-outlined-20.svg';
import cpuChip01Filled16 from './cpu-chip-01/cpu-chip-01-filled-16.svg';
import creditCard02Filled16 from './credit-card-02/credit-card-02-filled-16.svg';
import creditCard02Filled20 from './credit-card-02/credit-card-02-filled-20.svg';
import creditCard02Outlined16 from './credit-card-02/credit-card-02-outlined-16.svg';
import crownFilled16 from './crown/crown-filled-16.svg';
import cube01Filled16 from './cube-01/cube-01-filled-16.svg';
import cube01Filled20 from './cube-01/cube-01-filled-20.svg';
import cube01Outlined12 from './cube-01/cube-01-outlined-12.svg';
import cube01Outlined16 from './cube-01/cube-01-outlined-16.svg';
import cube01Outlined20 from './cube-01/cube-01-outlined-20.svg';
import cube01OffOutlined12 from './cube-01-off/cube-01-off-outlined-12.svg';
import cube01OffOutlined16 from './cube-01-off/cube-01-off-outlined-16.svg';
import cube01OffOutlined20 from './cube-01-off/cube-01-off-outlined-20.svg';
import cubeOutlineOutlined12 from './cube-outline/cube-outline-outlined-12.svg';
import cursorClickFilled16 from './cursor-click/cursor-click-filled-16.svg';
import customerPortalFilled12 from './customer-portal/customer-portal-filled-12.svg';
import customerPortalFilled16 from './customer-portal/customer-portal-filled-16.svg';
import customerPortalFilled20 from './customer-portal/customer-portal-filled-20.svg';
import customerPortalOutlined12 from './customer-portal/customer-portal-outlined-12.svg';
import customerPortalOutlined16 from './customer-portal/customer-portal-outlined-16.svg';
import dataflow02Filled16 from './dataflow-02/dataflow-02-filled-16.svg';
import dataflow02Filled20 from './dataflow-02/dataflow-02-filled-20.svg';
import dataflow02Outlined16 from './dataflow-02/dataflow-02-outlined-16.svg';
import dataflow02Outlined20 from './dataflow-02/dataflow-02-outlined-20.svg';
import deleteOutlined20 from './delete/delete-outlined-20.svg';
import deliverabilityFilled16 from './deliverability/deliverability-filled-16.svg';
import deliverabilityFilled20 from './deliverability/deliverability-filled-20.svg';
import deliverabilityOutlined16 from './deliverability/deliverability-outlined-16.svg';
import diamond01Filled12 from './diamond-01/diamond-01-filled-12.svg';
import diamond01Filled16 from './diamond-01/diamond-01-filled-16.svg';
import diamond01Outlined16 from './diamond-01/diamond-01-outlined-16.svg';
import discussionsFilled12 from './discussions/discussions-filled-12.svg';
import discussionsFilled16 from './discussions/discussions-filled-16.svg';
import discussionsOutlined12 from './discussions/discussions-outlined-12.svg';
import discussionsOutlined16 from './discussions/discussions-outlined-16.svg';
import discussionsOutlined20 from './discussions/discussions-outlined-20.svg';
import distributeSpacingVerticalFilled20 from './distribute-spacing-vertical/distribute-spacing-vertical-filled-20.svg';
import distributeSpacingVerticalOutlined20 from './distribute-spacing-vertical/distribute-spacing-vertical-outlined-20.svg';
import dividerOutlined16 from './divider/divider-outlined-16.svg';
import dividerOutlined20 from './divider/divider-outlined-20.svg';
import donutChartOutlined16 from './donut-chart/donut-chart-outlined-16.svg';
import doorOpenOutlined16 from './door-open/door-open-outlined-16.svg';
import dotpoints01Outlined12 from './dotpoints-01/dotpoints-01-outlined-12.svg';
import dotpoints01Outlined16 from './dotpoints-01/dotpoints-01-outlined-16.svg';
import dotpoints01Outlined20 from './dotpoints-01/dotpoints-01-outlined-20.svg';
import dotsGridFilled20 from './dots-grid/dots-grid-filled-20.svg';
import dotsGridOutlined20 from './dots-grid/dots-grid-outlined-20.svg';
import dotsHorizontalOutlined16 from './dots-horizontal/dots-horizontal-outlined-16.svg';
import dotsHorizontalOutlined20 from './dots-horizontal/dots-horizontal-outlined-20.svg';
import dotsVerticalOutlined16 from './dots-vertical/dots-vertical-outlined-16.svg';
import dotsVerticalOutlined20 from './dots-vertical/dots-vertical-outlined-20.svg';
import download02Filled16 from './download-02/download-02-filled-16.svg';
import download02Filled20 from './download-02/download-02-filled-20.svg';
import download02Outlined12 from './download-02/download-02-outlined-12.svg';
import download02Outlined16 from './download-02/download-02-outlined-16.svg';
import download02Outlined20 from './download-02/download-02-outlined-20.svg';
import edit01Filled20 from './edit-01/edit-01-filled-20.svg';
import edit01Outlined12 from './edit-01/edit-01-outlined-12.svg';
import edit01Outlined16 from './edit-01/edit-01-outlined-16.svg';
import edit01Outlined20 from './edit-01/edit-01-outlined-20.svg';
import edit05Filled16 from './edit-05/edit-05-filled-16.svg';
import edit05Outlined16 from './edit-05/edit-05-outlined-16.svg';
import edit05Outlined20 from './edit-05/edit-05-outlined-20.svg';
import emojiActivityOutlined16 from './emoji-activity/emoji-activity-outlined-16.svg';
import emojiFoodOutlined20 from './emoji-food/emoji-food-outlined-20.svg';
import emojiNatureOutlined20 from './emoji-nature/emoji-nature-outlined-20.svg';
import emojiSymbolsFilled16 from './emoji-symbols/emoji-symbols-filled-16.svg';
import emojiSymbolsOutlined16 from './emoji-symbols/emoji-symbols-outlined-16.svg';
import emojiSymbolsOutlined20 from './emoji-symbols/emoji-symbols-outlined-20.svg';
import expand01Outlined16 from './expand-01/expand-01-outlined-16.svg';
import expand01Outlined20 from './expand-01/expand-01-outlined-20.svg';
import exportOutlined16 from './export/export-outlined-16.svg';
import exportOutlined20 from './export/export-outlined-20.svg';
import eyeFilled12 from './eye/eye-filled-12.svg';
import eyeFilled16 from './eye/eye-filled-16.svg';
import eyeFilled20 from './eye/eye-filled-20.svg';
import eyeOutlined12 from './eye/eye-outlined-12.svg';
import eyeOutlined16 from './eye/eye-outlined-16.svg';
import eyeOffFilled16 from './eye-off/eye-off-filled-16.svg';
import eyeOffOutlined16 from './eye-off/eye-off-outlined-16.svg';
import faceSmileOutlined16 from './face-smile/face-smile-outlined-16.svg';
import faceSmileOutlined20 from './face-smile/face-smile-outlined-20.svg';
import facebookOutlined16 from './facebook/facebook-outlined-16.svg';
import featherFilled16 from './feather/feather-filled-16.svg';
import featherFilled20 from './feather/feather-filled-20.svg';
import featherOutlined16 from './feather/feather-outlined-16.svg';
import fieldCustomFilled16 from './field-custom/field-custom-filled-16.svg';
import fieldCustomFilled20 from './field-custom/field-custom-filled-20.svg';
import fieldCustomOutlined12 from './field-custom/field-custom-outlined-12.svg';
import fieldCustomOutlined16 from './field-custom/field-custom-outlined-16.svg';
import file02Filled16 from './file-02/file-02-filled-16.svg';
import file02Filled20 from './file-02/file-02-filled-20.svg';
import file02Outlined12 from './file-02/file-02-outlined-12.svg';
import file02Outlined16 from './file-02/file-02-outlined-16.svg';
import file02Outlined20 from './file-02/file-02-outlined-20.svg';
import file05Filled12 from './file-05/file-05-filled-12.svg';
import file05Filled16 from './file-05/file-05-filled-16.svg';
import file05Filled20 from './file-05/file-05-filled-20.svg';
import file05Outlined12 from './file-05/file-05-outlined-12.svg';
import file05Outlined16 from './file-05/file-05-outlined-16.svg';
import file05Outlined20 from './file-05/file-05-outlined-20.svg';
import fileCheck02Filled16 from './file-check-02/file-check-02-filled-16.svg';
import fileCheck02Outlined16 from './file-check-02/file-check-02-outlined-16.svg';
import fileDownload03Outlined16 from './file-download-03/file-download-03-outlined-16.svg';
import fileSearch01Filled16 from './file-search-01/file-search-01-filled-16.svg';
import filterLinesFilled16 from './filter-lines/filter-lines-filled-16.svg';
import filterLinesOutlined12 from './filter-lines/filter-lines-outlined-12.svg';
import filterLinesOutlined16 from './filter-lines/filter-lines-outlined-16.svg';
import filterLinesOutlined20 from './filter-lines/filter-lines-outlined-20.svg';
import firstPageFilled16 from './first-page/first-page-filled-16.svg';
import fixGrammarOutlined12 from './fix-grammar/fix-grammar-outlined-12.svg';
import fixGrammarOutlined16 from './fix-grammar/fix-grammar-outlined-16.svg';
import flag01Outlined16 from './flag-01/flag-01-outlined-16.svg';
import flag01Outlined20 from './flag-01/flag-01-outlined-20.svg';
import flipBackwardOutlined12 from './flip-backward/flip-backward-outlined-12.svg';
import flipBackwardOutlined16 from './flip-backward/flip-backward-outlined-16.svg';
import flipForwardPlusOutlined16 from './flip-forward-plus/flip-forward-plus-outlined-16.svg';
import floatingOutlined16 from './floating/floating-outlined-16.svg';
import floatingOutlined20 from './floating/floating-outlined-20.svg';
import focusOutlined20 from './focus/focus-outlined-20.svg';
import folderFilled16 from './folder/folder-filled-16.svg';
import folderFilled20 from './folder/folder-filled-20.svg';
import folderOutlined16 from './folder/folder-outlined-16.svg';
import folderOutlined20 from './folder/folder-outlined-20.svg';
import formattingOutlined16 from './formatting/formatting-outlined-16.svg';
import formattingOutlined20 from './formatting/formatting-outlined-20.svg';
import formattingColorOutlined16 from './formatting-color/formatting-color-outlined-16.svg';
import formattingColorOutlined20 from './formatting-color/formatting-color-outlined-20.svg';
import formattingHighlightOutlined16 from './formatting-highlight/formatting-highlight-outlined-16.svg';
import formattingHighlightOutlined20 from './formatting-highlight/formatting-highlight-outlined-20.svg';
import formattingListOutlined16 from './formatting-list/formatting-list-outlined-16.svg';
import formattingQuoteOutlined16 from './formatting-quote/formatting-quote-outlined-16.svg';
import formattingQuoteOutlined20 from './formatting-quote/formatting-quote-outlined-20.svg';
import forward10SFilled20 from './forward-10s/forward-10s-filled-20.svg';
import frontLogoFilled12 from './front-logo/front-logo-filled-12.svg';
import geometryFilled16 from './geometry/geometry-filled-16.svg';
import geometryOutlined16 from './geometry/geometry-outlined-16.svg';
import gifOutlined16 from './gif/gif-outlined-16.svg';
import gifOutlined20 from './gif/gif-outlined-20.svg';
import gift01Outlined16 from './gift-01/gift-01-outlined-16.svg';
import gitBranch01Filled12 from './git-branch-01/git-branch-01-filled-12.svg';
import gitBranch01Filled16 from './git-branch-01/git-branch-01-filled-16.svg';
import gitBranch01Filled20 from './git-branch-01/git-branch-01-filled-20.svg';
import gitBranch01Outlined12 from './git-branch-01/git-branch-01-outlined-12.svg';
import gitBranch01Outlined16 from './git-branch-01/git-branch-01-outlined-16.svg';
import globe01Filled16 from './globe-01/globe-01-filled-16.svg';
import globe01Outlined12 from './globe-01/globe-01-outlined-12.svg';
import globe01Outlined16 from './globe-01/globe-01-outlined-16.svg';
import globe01Outlined20 from './globe-01/globe-01-outlined-20.svg';
import globe04Filled20 from './globe-04/globe-04-filled-20.svg';
import goToConversationOutlined20 from './go-to-conversation/go-to-conversation-outlined-20.svg';
import googlePlayFilled16 from './google-play/google-play-filled-16.svg';
import googlePlayOutlined16 from './google-play/google-play-outlined-16.svg';
import grabHandleOutlined16 from './grab-handle/grab-handle-outlined-16.svg';
import graduationHat01Filled16 from './graduation-hat-01/graduation-hat-01-filled-16.svg';
import graduationHat01Outlined16 from './graduation-hat-01/graduation-hat-01-outlined-16.svg';
import graduationHat01Outlined20 from './graduation-hat-01/graduation-hat-01-outlined-20.svg';
import grammarOutlined16 from './grammar/grammar-outlined-16.svg';
import grid01Filled12 from './grid-01/grid-01-filled-12.svg';
import grid01Filled16 from './grid-01/grid-01-filled-16.svg';
import grid01Filled20 from './grid-01/grid-01-filled-20.svg';
import grid01Outlined12 from './grid-01/grid-01-outlined-12.svg';
import grid01Outlined16 from './grid-01/grid-01-outlined-16.svg';
import grid01Outlined20 from './grid-01/grid-01-outlined-20.svg';
import heartFilled20 from './heart/heart-filled-20.svg';
import heartOutlined16 from './heart/heart-outlined-16.svg';
import heartOutlined20 from './heart/heart-outlined-20.svg';
import helpCenterFilled16 from './help-center/help-center-filled-16.svg';
import helpCenterFilled20 from './help-center/help-center-filled-20.svg';
import helpCenterOutlined16 from './help-center/help-center-outlined-16.svg';
import helpCircleFilled12 from './help-circle/help-circle-filled-12.svg';
import helpCircleFilled16 from './help-circle/help-circle-filled-16.svg';
import helpCircleFilled20 from './help-circle/help-circle-filled-20.svg';
import helpCircleOutlined12 from './help-circle/help-circle-outlined-12.svg';
import helpCircleOutlined16 from './help-circle/help-circle-outlined-16.svg';
import helpCircleOutlined20 from './help-circle/help-circle-outlined-20.svg';
import home05Filled16 from './home-05/home-05-filled-16.svg';
import home05Filled20 from './home-05/home-05-filled-20.svg';
import home05Outlined16 from './home-05/home-05-outlined-16.svg';
import hourglassCheckFilled16 from './hourglass-check/hourglass-check-filled-16.svg';
import hourglassCheckFilled20 from './hourglass-check/hourglass-check-filled-20.svg';
import hourglassCheckOutlined16 from './hourglass-check/hourglass-check-outlined-16.svg';
import hourglassCheckOutlined20 from './hourglass-check/hourglass-check-outlined-20.svg';
import image03Filled16 from './image-03/image-03-filled-16.svg';
import image03Outlined20 from './image-03/image-03-outlined-20.svg';
import inbox01Filled12 from './inbox-01/inbox-01-filled-12.svg';
import inbox01Filled16 from './inbox-01/inbox-01-filled-16.svg';
import inbox01Filled20 from './inbox-01/inbox-01-filled-20.svg';
import inbox01Outlined12 from './inbox-01/inbox-01-outlined-12.svg';
import inbox01Outlined16 from './inbox-01/inbox-01-outlined-16.svg';
import inbox01Outlined20 from './inbox-01/inbox-01-outlined-20.svg';
import inboxListFilled12 from './inbox-list/inbox-list-filled-12.svg';
import inboxListFilled16 from './inbox-list/inbox-list-filled-16.svg';
import inboxListOutlined12 from './inbox-list/inbox-list-outlined-12.svg';
import inboxListOutlined16 from './inbox-list/inbox-list-outlined-16.svg';
import infoCircleFilled16 from './info-circle/info-circle-filled-16.svg';
import infoCircleFilled20 from './info-circle/info-circle-filled-20.svg';
import infoCircleOutlined16 from './info-circle/info-circle-outlined-16.svg';
import infoCircleOutlined20 from './info-circle/info-circle-outlined-20.svg';
import infoHistoryOutlined20 from './info-history/info-history-outlined-20.svg';
import intercomOutlined16 from './intercom/intercom-outlined-16.svg';
import italic01Outlined16 from './italic-01/italic-01-outlined-16.svg';
import italic01Outlined20 from './italic-01/italic-01-outlined-20.svg';
import keyMetricOutlined16 from './key-metric/key-metric-outlined-16.svg';
import keyboard02Filled20 from './keyboard-02/keyboard-02-filled-20.svg';
import laptopOutlined16 from './laptop/laptop-outlined-16.svg';
import lastPageOutlined16 from './last-page/last-page-outlined-16.svg';
import layersThree01Filled16 from './layers-three-01/layers-three-01-filled-16.svg';
import layersThree01Filled20 from './layers-three-01/layers-three-01-filled-20.svg';
import layersThree01Outlined12 from './layers-three-01/layers-three-01-outlined-12.svg';
import layersThree01Outlined16 from './layers-three-01/layers-three-01-outlined-16.svg';
import layoutAlt01Filled16 from './layout-alt-01/layout-alt-01-filled-16.svg';
import layoutAlt01Outlined16 from './layout-alt-01/layout-alt-01-outlined-16.svg';
import layoutAlt01Outlined20 from './layout-alt-01/layout-alt-01-outlined-20.svg';
import layoutGrid02Outlined16 from './layout-grid-02/layout-grid-02-outlined-16.svg';
import layoutLeftOutlined12 from './layout-left/layout-left-outlined-12.svg';
import layoutLeftOutlined16 from './layout-left/layout-left-outlined-16.svg';
import layoutLeftOutlined20 from './layout-left/layout-left-outlined-20.svg';
import layoutRightOutlined16 from './layout-right/layout-right-outlined-16.svg';
import layoutRightOutlined20 from './layout-right/layout-right-outlined-20.svg';
import lightbulb04Filled12 from './lightbulb-04/lightbulb-04-filled-12.svg';
import lightbulb04Filled16 from './lightbulb-04/lightbulb-04-filled-16.svg';
import lightbulb04Filled20 from './lightbulb-04/lightbulb-04-filled-20.svg';
import lightbulb04Filled24 from './lightbulb-04/lightbulb-04-filled-24.svg';
import lightbulb04Outlined16 from './lightbulb-04/lightbulb-04-outlined-16.svg';
import lightbulb04Outlined20 from './lightbulb-04/lightbulb-04-outlined-20.svg';
import lightning01Filled12 from './lightning-01/lightning-01-filled-12.svg';
import lightning01Filled16 from './lightning-01/lightning-01-filled-16.svg';
import lightning01Filled20 from './lightning-01/lightning-01-filled-20.svg';
import lightning01Outlined12 from './lightning-01/lightning-01-outlined-12.svg';
import lightning01Outlined16 from './lightning-01/lightning-01-outlined-16.svg';
import lightning01Outlined20 from './lightning-01/lightning-01-outlined-20.svg';
import lineChartUp01Outlined16 from './line-chart-up-01/line-chart-up-01-outlined-16.svg';
import linearRuleFilled16 from './linear-rule/linear-rule-filled-16.svg';
import linearRuleFilled20 from './linear-rule/linear-rule-filled-20.svg';
import linearRuleOutlined16 from './linear-rule/linear-rule-outlined-16.svg';
import link03Outlined12 from './link-03/link-03-outlined-12.svg';
import link03Outlined16 from './link-03/link-03-outlined-16.svg';
import link03Outlined20 from './link-03/link-03-outlined-20.svg';
import linkBroken03Filled16 from './link-broken-03/link-broken-03-filled-16.svg';
import linkBroken03Filled20 from './link-broken-03/link-broken-03-filled-20.svg';
import linkBroken03Outlined12 from './link-broken-03/link-broken-03-outlined-12.svg';
import linkBroken03Outlined16 from './link-broken-03/link-broken-03-outlined-16.svg';
import linkBroken03Outlined20 from './link-broken-03/link-broken-03-outlined-20.svg';
import linkExternal02Outlined16 from './link-external-02/link-external-02-outlined-16.svg';
import linkToFilled16 from './link-to/link-to-filled-16.svg';
import linkToOutlined16 from './link-to/link-to-outlined-16.svg';
import lock01Filled12 from './lock-01/lock-01-filled-12.svg';
import lock01Filled16 from './lock-01/lock-01-filled-16.svg';
import lock01Filled20 from './lock-01/lock-01-filled-20.svg';
import lock01Outlined16 from './lock-01/lock-01-outlined-16.svg';
import lock01Outlined20 from './lock-01/lock-01-outlined-20.svg';
import lockUnlocked01Outlined16 from './lock-unlocked-01/lock-unlocked-01-outlined-16.svg';
import logOut02Outlined16 from './log-out-02/log-out-02-outlined-16.svg';
import longerOutlined12 from './longer/longer-outlined-12.svg';
import longerOutlined16 from './longer/longer-outlined-16.svg';
import mail01Filled12 from './mail-01/mail-01-filled-12.svg';
import mail01Filled16 from './mail-01/mail-01-filled-16.svg';
import mail01Filled20 from './mail-01/mail-01-filled-20.svg';
import mail01Outlined12 from './mail-01/mail-01-outlined-12.svg';
import mail01Outlined16 from './mail-01/mail-01-outlined-16.svg';
import mail01Outlined20 from './mail-01/mail-01-outlined-20.svg';
import mail04Outlined16 from './mail-04/mail-04-outlined-16.svg';
import mailNotificationOutlined16 from './mail-notification/mail-notification-outlined-16.svg';
import markerPin01Outlined16 from './marker-pin-01/marker-pin-01-outlined-16.svg';
import menu01Outlined20 from './menu-01/menu-01-outlined-20.svg';
import mergeFilled12 from './merge/merge-filled-12.svg';
import mergeFilled16 from './merge/merge-filled-16.svg';
import mergeOutlined12 from './merge/merge-outlined-12.svg';
import mergeOutlined16 from './merge/merge-outlined-16.svg';
import mergeOutlined20 from './merge/merge-outlined-20.svg';
import messageSquare01Filled20 from './message-square-01/message-square-01-filled-20.svg';
import messageSquare01Outlined12 from './message-square-01/message-square-01-outlined-12.svg';
import messageSquare01Outlined16 from './message-square-01/message-square-01-outlined-16.svg';
import messageSquare01Outlined20 from './message-square-01/message-square-01-outlined-20.svg';
import messageTemplateFilled12 from './message-template/message-template-filled-12.svg';
import messageTemplateFilled16 from './message-template/message-template-filled-16.svg';
import messageTemplateFilled20 from './message-template/message-template-filled-20.svg';
import messageTemplateOutlined12 from './message-template/message-template-outlined-12.svg';
import messageTemplateOutlined16 from './message-template/message-template-outlined-16.svg';
import messageTemplateOutlined20 from './message-template/message-template-outlined-20.svg';
import messageTextCircle02Filled16 from './message-text-circle-02/message-text-circle-02-filled-16.svg';
import messageTextCircle02Filled20 from './message-text-circle-02/message-text-circle-02-filled-20.svg';
import messageTextCircle02Outlined20 from './message-text-circle-02/message-text-circle-02-outlined-20.svg';
import microphone01Outlined16 from './microphone-01/microphone-01-outlined-16.svg';
import minimize01Outlined16 from './minimize-01/minimize-01-outlined-16.svg';
import minimize01Outlined20 from './minimize-01/minimize-01-outlined-20.svg';
import minusOutlined16 from './minus/minus-outlined-16.svg';
import minusOutlined20 from './minus/minus-outlined-20.svg';
import minusCircleFilled12 from './minus-circle/minus-circle-filled-12.svg';
import minusCircleFilled16 from './minus-circle/minus-circle-filled-16.svg';
import minusCircleOutlined12 from './minus-circle/minus-circle-outlined-12.svg';
import minusCircleOutlined16 from './minus-circle/minus-circle-outlined-16.svg';
import moon02Filled16 from './moon-02/moon-02-filled-16.svg';
import moon02Outlined16 from './moon-02/moon-02-outlined-16.svg';
import mutedStatusFilled12 from './muted-status/muted-status-filled-12.svg';
import numbersOutlined12 from './numbers/numbers-outlined-12.svg';
import numbersOutlined16 from './numbers/numbers-outlined-16.svg';
import numbersOutlined20 from './numbers/numbers-outlined-20.svg';
import openFilled16 from './open/open-filled-16.svg';
import outboxFilled16 from './outbox/outbox-filled-16.svg';
import outboxFilled20 from './outbox/outbox-filled-20.svg';
import outboxOutlined16 from './outbox/outbox-outlined-16.svg';
import paperclipOutlined12 from './paperclip/paperclip-outlined-12.svg';
import paperclipOutlined16 from './paperclip/paperclip-outlined-16.svg';
import paperclipOutlined20 from './paperclip/paperclip-outlined-20.svg';
import paragraphSpacingOutlined16 from './paragraph-spacing/paragraph-spacing-outlined-16.svg';
import pauseFilled20 from './pause/pause-filled-20.svg';
import pauseCircleFilled20 from './pause-circle/pause-circle-filled-20.svg';
import pauseCircleOutlined16 from './pause-circle/pause-circle-outlined-16.svg';
import pauseCircleOutlined20 from './pause-circle/pause-circle-outlined-20.svg';
import personSpeakingOutlined16 from './person-speaking/person-speaking-outlined-16.svg';
import phoneFilled20 from './phone/phone-filled-20.svg';
import phoneOutlined12 from './phone/phone-outlined-12.svg';
import phoneOutlined16 from './phone/phone-outlined-16.svg';
import phoneOutlined20 from './phone/phone-outlined-20.svg';
import phoneCall01Filled16 from './phone-call-01/phone-call-01-filled-16.svg';
import phoneCall01Filled20 from './phone-call-01/phone-call-01-filled-20.svg';
import phoneCall01Outlined12 from './phone-call-01/phone-call-01-outlined-12.svg';
import phoneCall01Outlined16 from './phone-call-01/phone-call-01-outlined-16.svg';
import phoneCall01Outlined20 from './phone-call-01/phone-call-01-outlined-20.svg';
import phoneHangUpOutlined12 from './phone-hang-up/phone-hang-up-outlined-12.svg';
import phoneHangUpOutlined20 from './phone-hang-up/phone-hang-up-outlined-20.svg';
import phoneIncoming01Filled16 from './phone-incoming-01/phone-incoming-01-filled-16.svg';
import phoneIncoming01Outlined12 from './phone-incoming-01/phone-incoming-01-outlined-12.svg';
import phoneOutgoing01Filled16 from './phone-outgoing-01/phone-outgoing-01-filled-16.svg';
import phoneOutgoing02Outlined12 from './phone-outgoing-02/phone-outgoing-02-outlined-12.svg';
import phonePauseOutlined12 from './phone-pause/phone-pause-outlined-12.svg';
import phoneXFilled16 from './phone-x/phone-x-filled-16.svg';
import phoneXOutlined12 from './phone-x/phone-x-outlined-12.svg';
import pieChart01Outlined16 from './pie-chart-01/pie-chart-01-outlined-16.svg';
import pin02Filled12 from './pin-02/pin-02-filled-12.svg';
import pin02Filled16 from './pin-02/pin-02-filled-16.svg';
import pin02Outlined16 from './pin-02/pin-02-outlined-16.svg';
import pinToBottomOutlined16 from './pin-to-bottom/pin-to-bottom-outlined-16.svg';
import pinToRightOutlined16 from './pin-to-right/pin-to-right-outlined-16.svg';
import pinToRightOutlined20 from './pin-to-right/pin-to-right-outlined-20.svg';
import planTemplateFilled12 from './plan-template/plan-template-filled-12.svg';
import planTemplateFilled16 from './plan-template/plan-template-filled-16.svg';
import planTemplateFilled20 from './plan-template/plan-template-filled-20.svg';
import planTemplateFilled24 from './plan-template/plan-template-filled-24.svg';
import planTemplateOutlined12 from './plan-template/plan-template-outlined-12.svg';
import planTemplateOutlined16 from './plan-template/plan-template-outlined-16.svg';
import planTemplateOutlined20 from './plan-template/plan-template-outlined-20.svg';
import planTemplateOutlined24 from './plan-template/plan-template-outlined-24.svg';
import planeOutlined20 from './plane/plane-outlined-20.svg';
import playFilled20 from './play/play-filled-20.svg';
import playOutlined12 from './play/play-outlined-12.svg';
import playOutlined16 from './play/play-outlined-16.svg';
import playCircleOutlined16 from './play-circle/play-circle-outlined-16.svg';
import playbookTemporaryFilled12 from './playbook-temporary/playbook-temporary-filled-12.svg';
import playbookTemporaryFilled16 from './playbook-temporary/playbook-temporary-filled-16.svg';
import playbookTemporaryFilled20 from './playbook-temporary/playbook-temporary-filled-20.svg';
import playbookTemporaryFilled24 from './playbook-temporary/playbook-temporary-filled-24.svg';
import playbookTemporaryOutlined12 from './playbook-temporary/playbook-temporary-outlined-12.svg';
import playbookTemporaryOutlined16 from './playbook-temporary/playbook-temporary-outlined-16.svg';
import playbookTemporaryOutlined20 from './playbook-temporary/playbook-temporary-outlined-20.svg';
import plusOutlined12 from './plus/plus-outlined-12.svg';
import plusOutlined16 from './plus/plus-outlined-16.svg';
import plusOutlined20 from './plus/plus-outlined-20.svg';
import plusCircleFilled16 from './plus-circle/plus-circle-filled-16.svg';
import plusCircleOutlined16 from './plus-circle/plus-circle-outlined-16.svg';
import plusCircleOutlined20 from './plus-circle/plus-circle-outlined-20.svg';
import popinOutlined20 from './popin/popin-outlined-20.svg';
import printerOutlined16 from './printer/printer-outlined-16.svg';
import puzzlePieceOutlined16 from './puzzle-piece/puzzle-piece-outlined-16.svg';
import qASmartFilled16 from './q-a-smart/q-a-smart-filled-16.svg';
import qASmartFilled20 from './q-a-smart/q-a-smart-filled-20.svg';
import qASmartOutlined16 from './q-a-smart/q-a-smart-outlined-16.svg';
import refreshCw01Filled16 from './refresh-cw-01/refresh-cw-01-filled-16.svg';
import refreshCw01Filled20 from './refresh-cw-01/refresh-cw-01-filled-20.svg';
import refreshCw01Outlined12 from './refresh-cw-01/refresh-cw-01-outlined-12.svg';
import refreshCw01Outlined16 from './refresh-cw-01/refresh-cw-01-outlined-16.svg';
import refreshCw01Outlined20 from './refresh-cw-01/refresh-cw-01-outlined-20.svg';
import refreshCw02Outlined16 from './refresh-cw-02/refresh-cw-02-outlined-16.svg';
import refreshCw02Outlined20 from './refresh-cw-02/refresh-cw-02-outlined-20.svg';
import repeat01Outlined16 from './repeat-01/repeat-01-outlined-16.svg';
import repeat01Outlined20 from './repeat-01/repeat-01-outlined-20.svg';
import repeat02Outlined16 from './repeat-02/repeat-02-outlined-16.svg';
import replaceAllOutlined16 from './replace-all/replace-all-outlined-16.svg';
import rewind10SFilled20 from './rewind-10s/rewind-10s-filled-20.svg';
import rocket02Filled16 from './rocket-02/rocket-02-filled-16.svg';
import rocket02Filled20 from './rocket-02/rocket-02-filled-20.svg';
import ruleTesterOutlined16 from './rule-tester/rule-tester-outlined-16.svg';
import ruleTesterOutlined20 from './rule-tester/rule-tester-outlined-20.svg';
import saveOutlined20 from './save/save-outlined-20.svg';
import scheduleFilled16 from './schedule/schedule-filled-16.svg';
import scheduleOutlined16 from './schedule/schedule-outlined-16.svg';
import scheduleOutlined20 from './schedule/schedule-outlined-20.svg';
import searchSmOutlined12 from './search-sm/search-sm-outlined-12.svg';
import searchSmOutlined16 from './search-sm/search-sm-outlined-16.svg';
import searchSmOutlined20 from './search-sm/search-sm-outlined-20.svg';
import sendFilled16 from './send/send-filled-16.svg';
import sendFilled20 from './send/send-filled-20.svg';
import sendOutlined12 from './send/send-outlined-12.svg';
import sendOutlined16 from './send/send-outlined-16.svg';
import sendOutlined20 from './send/send-outlined-20.svg';
import send04Outlined16 from './send-04/send-04-outlined-16.svg';
import settings02Filled12 from './settings-02/settings-02-filled-12.svg';
import settings02Filled16 from './settings-02/settings-02-filled-16.svg';
import settings02Filled20 from './settings-02/settings-02-filled-20.svg';
import settings02Outlined12 from './settings-02/settings-02-outlined-12.svg';
import settings02Outlined16 from './settings-02/settings-02-outlined-16.svg';
import settings02Outlined20 from './settings-02/settings-02-outlined-20.svg';
import settings03Filled12 from './settings-03/settings-03-filled-12.svg';
import settings03Filled16 from './settings-03/settings-03-filled-16.svg';
import settings03Filled20 from './settings-03/settings-03-filled-20.svg';
import settings03Outlined12 from './settings-03/settings-03-outlined-12.svg';
import settings03Outlined16 from './settings-03/settings-03-outlined-16.svg';
import settings03Outlined20 from './settings-03/settings-03-outlined-20.svg';
import shieldFilled20 from './shield/shield-filled-20.svg';
import shiftFilled16 from './shift/shift-filled-16.svg';
import shiftOutlined16 from './shift/shift-outlined-16.svg';
import shorterOutlined12 from './shorter/shorter-outlined-12.svg';
import shorterOutlined16 from './shorter/shorter-outlined-16.svg';
import sidebarFilled16 from './sidebar/sidebar-filled-16.svg';
import sidebarOutlined16 from './sidebar/sidebar-outlined-16.svg';
import sidebarOutlined20 from './sidebar/sidebar-outlined-20.svg';
import slackFilled16 from './slack/slack-filled-16.svg';
import slashCircle01Outlined16 from './slash-circle-01/slash-circle-01-outlined-16.svg';
import slashCircle01Outlined20 from './slash-circle-01/slash-circle-01-outlined-20.svg';
import sliders04Filled16 from './sliders-04/sliders-04-filled-16.svg';
import sliders04Outlined16 from './sliders-04/sliders-04-outlined-16.svg';
import smartProductsFilled12 from './smart-products/smart-products-filled-12.svg';
import smartProductsFilled16 from './smart-products/smart-products-filled-16.svg';
import smartProductsFilled20 from './smart-products/smart-products-filled-20.svg';
import smartProductsFilled24 from './smart-products/smart-products-filled-24.svg';
import smartProductsOutlined12 from './smart-products/smart-products-outlined-12.svg';
import smartProductsOutlined16 from './smart-products/smart-products-outlined-16.svg';
import smartProductsOutlined20 from './smart-products/smart-products-outlined-20.svg';
import smartProductsOutlined24 from './smart-products/smart-products-outlined-24.svg';
import splitFilled12 from './split/split-filled-12.svg';
import splitFilled16 from './split/split-filled-16.svg';
import splitOutlined12 from './split/split-outlined-12.svg';
import splitOutlined16 from './split/split-outlined-16.svg';
import squareFilled12 from './square/square-filled-12.svg';
import squareFilled16 from './square/square-filled-16.svg';
import squareFilled20 from './square/square-filled-20.svg';
import stackedBarOutlined16 from './stacked-bar/stacked-bar-outlined-16.svg';
import star01Filled12 from './star-01/star-01-filled-12.svg';
import star01Filled16 from './star-01/star-01-filled-16.svg';
import star01Filled20 from './star-01/star-01-filled-20.svg';
import star01Outlined16 from './star-01/star-01-outlined-16.svg';
import star01Outlined20 from './star-01/star-01-outlined-20.svg';
import star04Filled12 from './star-04/star-04-filled-12.svg';
import star04Filled16 from './star-04/star-04-filled-16.svg';
import star04Filled20 from './star-04/star-04-filled-20.svg';
import star04Outlined16 from './star-04/star-04-outlined-16.svg';
import star04Outlined20 from './star-04/star-04-outlined-20.svg';
import stars01Filled12 from './stars-01/stars-01-filled-12.svg';
import statusChangeFilled16 from './status-change/status-change-filled-16.svg';
import statusChangeFilled20 from './status-change/status-change-filled-20.svg';
import statusChangeOutlined16 from './status-change/status-change-outlined-16.svg';
import statusChangeOutlined20 from './status-change/status-change-outlined-20.svg';
import stickerSquareOutlined12 from './sticker-square/sticker-square-outlined-12.svg';
import stickerSquareOutlined16 from './sticker-square/sticker-square-outlined-16.svg';
import strikethrough01Outlined16 from './strikethrough-01/strikethrough-01-outlined-16.svg';
import strikethrough01Outlined20 from './strikethrough-01/strikethrough-01-outlined-20.svg';
import sunOutlined16 from './sun/sun-outlined-16.svg';
import switchHorizontal01Filled16 from './switch-horizontal-01/switch-horizontal-01-filled-16.svg';
import switchHorizontal01Outlined12 from './switch-horizontal-01/switch-horizontal-01-outlined-12.svg';
import switchHorizontal01Outlined20 from './switch-horizontal-01/switch-horizontal-01-outlined-20.svg';
import switchVertical01Outlined16 from './switch-vertical-01/switch-vertical-01-outlined-16.svg';
import tableFilled16 from './table/table-filled-16.svg';
import tableFilled20 from './table/table-filled-20.svg';
import tableOutlined16 from './table/table-outlined-16.svg';
import tableOutlined20 from './table/table-outlined-20.svg';
import tableColumnOutlined16 from './table-column/table-column-outlined-16.svg';
import tableColumnOutlined20 from './table-column/table-column-outlined-20.svg';
import tag01Filled12 from './tag-01/tag-01-filled-12.svg';
import tag01Filled16 from './tag-01/tag-01-filled-16.svg';
import tag01Filled20 from './tag-01/tag-01-filled-20.svg';
import tag01Outlined12 from './tag-01/tag-01-outlined-12.svg';
import tag01Outlined16 from './tag-01/tag-01-outlined-16.svg';
import tag01Outlined20 from './tag-01/tag-01-outlined-20.svg';
import tag03Filled12 from './tag-03/tag-03-filled-12.svg';
import tag03Filled16 from './tag-03/tag-03-filled-16.svg';
import tag03Outlined12 from './tag-03/tag-03-outlined-12.svg';
import tag03Outlined16 from './tag-03/tag-03-outlined-16.svg';
import tag03Outlined20 from './tag-03/tag-03-outlined-20.svg';
import tag04Filled12 from './tag-04/tag-04-filled-12.svg';
import tag04Filled16 from './tag-04/tag-04-filled-16.svg';
import tag04Filled20 from './tag-04/tag-04-filled-20.svg';
import tag04Outlined12 from './tag-04/tag-04-outlined-12.svg';
import tag04Outlined16 from './tag-04/tag-04-outlined-16.svg';
import target03Filled12 from './target-03/target-03-filled-12.svg';
import target03Filled16 from './target-03/target-03-filled-16.svg';
import target03Outlined12 from './target-03/target-03-outlined-12.svg';
import target03Outlined16 from './target-03/target-03-outlined-16.svg';
import targetOffOutlined16 from './target-off/target-off-outlined-16.svg';
import targetStroke03Outlined16 from './target-stroke-03/target-stroke-03-outlined-16.svg';
import taskFilled12 from './task/task-filled-12.svg';
import taskFilled16 from './task/task-filled-16.svg';
import taskFilled20 from './task/task-filled-20.svg';
import taskOutlined12 from './task/task-outlined-12.svg';
import taskOutlined16 from './task/task-outlined-16.svg';
import taskOutlined20 from './task/task-outlined-20.svg';
import task02Filled12 from './task-02/task-02-filled-12.svg';
import task02Filled16 from './task-02/task-02-filled-16.svg';
import task02Filled20 from './task-02/task-02-filled-20.svg';
import task02Filled24 from './task-02/task-02-filled-24.svg';
import task02Outlined12 from './task-02/task-02-outlined-12.svg';
import task02Outlined16 from './task-02/task-02-outlined-16.svg';
import task02Outlined20 from './task-02/task-02-outlined-20.svg';
import task02Outlined24 from './task-02/task-02-outlined-24.svg';
import taskTemplateFilled12 from './task-template/task-template-filled-12.svg';
import taskTemplateFilled16 from './task-template/task-template-filled-16.svg';
import taskTemplateFilled20 from './task-template/task-template-filled-20.svg';
import taskTemplateFilled24 from './task-template/task-template-filled-24.svg';
import taskTemplateOutlined12 from './task-template/task-template-outlined-12.svg';
import taskTemplateOutlined16 from './task-template/task-template-outlined-16.svg';
import taskTemplateOutlined20 from './task-template/task-template-outlined-20.svg';
import taskTemplateOutlined24 from './task-template/task-template-outlined-24.svg';
import templateFilled12 from './template/template-filled-12.svg';
import templateFilled16 from './template/template-filled-16.svg';
import templateFilled20 from './template/template-filled-20.svg';
import templateFilled24 from './template/template-filled-24.svg';
import templateOutlined12 from './template/template-outlined-12.svg';
import templateOutlined16 from './template/template-outlined-16.svg';
import templateOutlined20 from './template/template-outlined-20.svg';
import templateOutlined24 from './template/template-outlined-24.svg';
import thumbsDownFilled16 from './thumbs-down/thumbs-down-filled-16.svg';
import thumbsDownFilled20 from './thumbs-down/thumbs-down-filled-20.svg';
import thumbsDownOutlined16 from './thumbs-down/thumbs-down-outlined-16.svg';
import thumbsDownOutlined20 from './thumbs-down/thumbs-down-outlined-20.svg';
import thumbsUpFilled16 from './thumbs-up/thumbs-up-filled-16.svg';
import thumbsUpFilled20 from './thumbs-up/thumbs-up-filled-20.svg';
import thumbsUpOutlined16 from './thumbs-up/thumbs-up-outlined-16.svg';
import thumbsUpOutlined20 from './thumbs-up/thumbs-up-outlined-20.svg';
import ticket01Filled12 from './ticket-01/ticket-01-filled-12.svg';
import ticket01Filled16 from './ticket-01/ticket-01-filled-16.svg';
import ticket01Outlined12 from './ticket-01/ticket-01-outlined-12.svg';
import ticket01Outlined16 from './ticket-01/ticket-01-outlined-16.svg';
import toolFilled20 from './tool/tool-filled-20.svg';
import toolOutlined16 from './tool/tool-outlined-16.svg';
import toolOutlined20 from './tool/tool-outlined-20.svg';
import translate01Outlined12 from './translate-01/translate-01-outlined-12.svg';
import translate01Outlined16 from './translate-01/translate-01-outlined-16.svg';
import trash03Filled16 from './trash-03/trash-03-filled-16.svg';
import trash03Filled20 from './trash-03/trash-03-filled-20.svg';
import trash03Outlined12 from './trash-03/trash-03-outlined-12.svg';
import trash03Outlined16 from './trash-03/trash-03-outlined-16.svg';
import trash03Outlined20 from './trash-03/trash-03-outlined-20.svg';
import truck01Filled20 from './truck-01/truck-01-filled-20.svg';
import twitterXFilled16 from './twitter-x/twitter-x-filled-16.svg';
import twitterXFilled20 from './twitter-x/twitter-x-filled-20.svg';
import twitterXOutlined16 from './twitter-x/twitter-x-outlined-16.svg';
import typeStrikethrough01Outlined16 from './type-strikethrough-01/type-strikethrough-01-outlined-16.svg';
import typeStrikethrough01Outlined20 from './type-strikethrough-01/type-strikethrough-01-outlined-20.svg';
import unassignedFilled16 from './unassigned/unassigned-filled-16.svg';
import unassignedOutlined16 from './unassigned/unassigned-outlined-16.svg';
import underline01Outlined16 from './underline-01/underline-01-outlined-16.svg';
import underline01Outlined20 from './underline-01/underline-01-outlined-20.svg';
import unpinOutlined16 from './unpin/unpin-outlined-16.svg';
import user01Filled12 from './user-01/user-01-filled-12.svg';
import user01Filled16 from './user-01/user-01-filled-16.svg';
import user01Filled20 from './user-01/user-01-filled-20.svg';
import user01Outlined12 from './user-01/user-01-outlined-12.svg';
import user01Outlined16 from './user-01/user-01-outlined-16.svg';
import user01Outlined20 from './user-01/user-01-outlined-20.svg';
import userCheck01Filled16 from './user-check-01/user-check-01-filled-16.svg';
import userCheck01Outlined16 from './user-check-01/user-check-01-outlined-16.svg';
import userCheck01Outlined20 from './user-check-01/user-check-01-outlined-20.svg';
import userCircleFilled16 from './user-circle/user-circle-filled-16.svg';
import userCircleFilled20 from './user-circle/user-circle-filled-20.svg';
import userCircleOutlined12 from './user-circle/user-circle-outlined-12.svg';
import userCircleOutlined16 from './user-circle/user-circle-outlined-16.svg';
import userCircleOutlined20 from './user-circle/user-circle-outlined-20.svg';
import userEditFilled16 from './user-edit/user-edit-filled-16.svg';
import userEditFilled20 from './user-edit/user-edit-filled-20.svg';
import userLeft01Filled12 from './user-left-01/user-left-01-filled-12.svg';
import userLeft01Filled16 from './user-left-01/user-left-01-filled-16.svg';
import userLeft01Filled20 from './user-left-01/user-left-01-filled-20.svg';
import userLeft01Outlined12 from './user-left-01/user-left-01-outlined-12.svg';
import userLeft01Outlined16 from './user-left-01/user-left-01-outlined-16.svg';
import userLeft01Outlined20 from './user-left-01/user-left-01-outlined-20.svg';
import userPlus01Outlined12 from './user-plus-01/user-plus-01-outlined-12.svg';
import userPlus01Outlined16 from './user-plus-01/user-plus-01-outlined-16.svg';
import userPlus01Outlined20 from './user-plus-01/user-plus-01-outlined-20.svg';
import userRight01Filled12 from './user-right-01/user-right-01-filled-12.svg';
import userRight01Filled16 from './user-right-01/user-right-01-filled-16.svg';
import userRight01Filled20 from './user-right-01/user-right-01-filled-20.svg';
import userRight01Outlined12 from './user-right-01/user-right-01-outlined-12.svg';
import userRight01Outlined16 from './user-right-01/user-right-01-outlined-16.svg';
import userRightOffFilled12 from './user-right-off/user-right-off-filled-12.svg';
import userRightOffFilled20 from './user-right-off/user-right-off-filled-20.svg';
import userRightOffOutlined16 from './user-right-off/user-right-off-outlined-16.svg';
import userSparkle01Filled16 from './user-sparkle-01/user-sparkle-01-filled-16.svg';
import userSquareFilled12 from './user-square/user-square-filled-12.svg';
import userSquareFilled16 from './user-square/user-square-filled-16.svg';
import userSquareFilled20 from './user-square/user-square-filled-20.svg';
import userSquareOutlined12 from './user-square/user-square-outlined-12.svg';
import userSquareOutlined16 from './user-square/user-square-outlined-16.svg';
import userSquareOutlined20 from './user-square/user-square-outlined-20.svg';
import userX01Filled16 from './user-x-01/user-x-01-filled-16.svg';
import userX01Filled20 from './user-x-01/user-x-01-filled-20.svg';
import userX01Outlined12 from './user-x-01/user-x-01-outlined-12.svg';
import userX01Outlined16 from './user-x-01/user-x-01-outlined-16.svg';
import usersFilled16 from './users/users-filled-16.svg';
import usersFilled20 from './users/users-filled-20.svg';
import usersOutlined16 from './users/users-outlined-16.svg';
import users01Filled12 from './users-01/users-01-filled-12.svg';
import users01Filled16 from './users-01/users-01-filled-16.svg';
import users01Filled20 from './users-01/users-01-filled-20.svg';
import users01Outlined12 from './users-01/users-01-outlined-12.svg';
import users01Outlined16 from './users-01/users-01-outlined-16.svg';
import users01Outlined20 from './users-01/users-01-outlined-20.svg';
import usersLeftOutlined20 from './users-left/users-left-outlined-20.svg';
import usersPlusOutlined16 from './users-plus/users-plus-outlined-16.svg';
import usersSparkleFilled24 from './users-sparkle/users-sparkle-filled-24.svg';
import usersSparkleOutlined16 from './users-sparkle/users-sparkle-outlined-16.svg';
import variableOutlined12 from './variable/variable-outlined-12.svg';
import variableOutlined16 from './variable/variable-outlined-16.svg';
import variableOutlined20 from './variable/variable-outlined-20.svg';
import videoRecorderOutlined16 from './video-recorder/video-recorder-outlined-16.svg';
import videoRecorderOutlined20 from './video-recorder/video-recorder-outlined-20.svg';
import viewsFilled12 from './views/views-filled-12.svg';
import viewsFilled16 from './views/views-filled-16.svg';
import viewsFilled20 from './views/views-filled-20.svg';
import viewsOutlined12 from './views/views-outlined-12.svg';
import viewsOutlined16 from './views/views-outlined-16.svg';
import viewsOutlined20 from './views/views-outlined-20.svg';
import visitorSourceOutlined16 from './visitor-source/visitor-source-outlined-16.svg';
import visitorSourceOutlined20 from './visitor-source/visitor-source-outlined-20.svg';
import voicemailFilled16 from './voicemail/voicemail-filled-16.svg';
import volumeMaxFilled20 from './volume-max/volume-max-filled-20.svg';
import whatsappOutlined16 from './whatsapp/whatsapp-outlined-16.svg';
import whatsappOutlined20 from './whatsapp/whatsapp-outlined-20.svg';
import windowsCloseOutlined20 from './windows-close/windows-close-outlined-20.svg';
import windowsMaximizeOutlined20 from './windows-maximize/windows-maximize-outlined-20.svg';
import windowsMinimizeOutlined20 from './windows-minimize/windows-minimize-outlined-20.svg';
import windowsUnmaximizeOutlined20 from './windows-unmaximize/windows-unmaximize-outlined-20.svg';
import workspaceFilled16 from './workspace/workspace-filled-16.svg';
import workspaceOutlined16 from './workspace/workspace-outlined-16.svg';
import xCircleFilled12 from './x-circle/x-circle-filled-12.svg';
import xCircleFilled16 from './x-circle/x-circle-filled-16.svg';
import xCircleFilled20 from './x-circle/x-circle-filled-20.svg';
import xCircleOutlined12 from './x-circle/x-circle-outlined-12.svg';
import xCircleOutlined16 from './x-circle/x-circle-outlined-16.svg';
import xCloseOutlined12 from './x-close/x-close-outlined-12.svg';
import xCloseOutlined16 from './x-close/x-close-outlined-16.svg';
import xCloseOutlined20 from './x-close/x-close-outlined-20.svg';

type SvgAssetMapSchema = Record<string, any>;

export type SvgAssetMap<T extends SvgAssetMapSchema> = {[K in keyof T]: SvgAsset};

function buildSvgAssetMap<T extends SvgAssetMapSchema>(schema: T): SvgAssetMap<T> {
  return schema;
}

export const webIcons = buildSvgAssetMap({
  'add-link/outlined/16': addLinkOutlined16,
  'add-reaction/outlined/16': addReactionOutlined16,
  'adjust-tone/outlined/12': adjustToneOutlined12,
  'adjust-tone/outlined/16': adjustToneOutlined16,
  'agent/filled/16': agentFilled16,
  'agent/outlined/16': agentOutlined16,
  'ai-agent/filled/12': aiAgentFilled12,
  'ai-agent/filled/16': aiAgentFilled16,
  'ai-agent/outlined/16': aiAgentOutlined16,
  'ai-compose/outlined/12': aiComposeOutlined12,
  'ai-compose/outlined/16': aiComposeOutlined16,
  'ai-compose/outlined/20': aiComposeOutlined20,
  'ai-connectors/filled/12': aiConnectorsFilled12,
  'ai-connectors/filled/16': aiConnectorsFilled16,
  'ai-connectors/filled/20': aiConnectorsFilled20,
  'ai-connectors/outlined/12': aiConnectorsOutlined12,
  'ai-connectors/outlined/16': aiConnectorsOutlined16,
  'ai-connectors/outlined/20': aiConnectorsOutlined20,
  'ai-solid/filled/16': aiSolidFilled16,
  'ai-solid/outlined/16': aiSolidOutlined16,
  'ai-summary/outlined/16': aiSummaryOutlined16,
  'ai/gradient/16': aiGradient16,
  'ai/gradient/20': aiGradient20,
  'ai/gradient/32': aiGradient32,
  'ai/solid/16': aiSolid16,
  'alarm-clock/filled/12': alarmClockFilled12,
  'alarm-clock/filled/16': alarmClockFilled16,
  'alarm-clock/filled/20': alarmClockFilled20,
  'alarm-clock/outlined/12': alarmClockOutlined12,
  'alarm-clock/outlined/16': alarmClockOutlined16,
  'alarm-clock/outlined/20': alarmClockOutlined20,
  'alert-circle/filled/12': alertCircleFilled12,
  'alert-circle/filled/16': alertCircleFilled16,
  'alert-circle/filled/20': alertCircleFilled20,
  'alert-circle/outlined/12': alertCircleOutlined12,
  'alert-circle/outlined/16': alertCircleOutlined16,
  'alert-circle/outlined/20': alertCircleOutlined20,
  'alert-hexagon/filled/12': alertHexagonFilled12,
  'alert-hexagon/filled/16': alertHexagonFilled16,
  'alert-hexagon/filled/20': alertHexagonFilled20,
  'alert-hexagon/outlined/12': alertHexagonOutlined12,
  'alert-hexagon/outlined/16': alertHexagonOutlined16,
  'alert-hexagon/outlined/20': alertHexagonOutlined20,
  'alert-square/outlined/16': alertSquareOutlined16,
  'alert-triangle/filled/12': alertTriangleFilled12,
  'alert-triangle/filled/16': alertTriangleFilled16,
  'alert-triangle/filled/20': alertTriangleFilled20,
  'alert-triangle/outlined/12': alertTriangleOutlined12,
  'alert-triangle/outlined/16': alertTriangleOutlined16,
  'alert-triangle/outlined/20': alertTriangleOutlined20,
  'align-left/outlined/12': alignLeftOutlined12,
  'align-left/outlined/16': alignLeftOutlined16,
  'align-left/outlined/20': alignLeftOutlined20,
  'align-vertical-center/outlined/16': alignVerticalCenterOutlined16,
  'archive-off/filled/12': archiveOffFilled12,
  'archive-off/filled/16': archiveOffFilled16,
  'archive-off/filled/20': archiveOffFilled20,
  'archive-off/outlined/12': archiveOffOutlined12,
  'archive/filled/12': archiveFilled12,
  'archive/filled/16': archiveFilled16,
  'archive/filled/20': archiveFilled20,
  'archive/outlined/12': archiveOutlined12,
  'archive/outlined/16': archiveOutlined16,
  'archive/outlined/20': archiveOutlined20,
  'arrow-block-right/filled/12': arrowBlockRightFilled12,
  'arrow-block-right/filled/16': arrowBlockRightFilled16,
  'arrow-block-right/filled/20': arrowBlockRightFilled20,
  'arrow-block-right/outlined/12': arrowBlockRightOutlined12,
  'arrow-block-right/outlined/16': arrowBlockRightOutlined16,
  'arrow-block-right/outlined/20': arrowBlockRightOutlined20,
  'arrow-circle-broken-right/filled/16': arrowCircleBrokenRightFilled16,
  'arrow-narrow-down-right/outlined/16': arrowNarrowDownRightOutlined16,
  'arrow-narrow-down/filled/16': arrowNarrowDownFilled16,
  'arrow-narrow-down/outlined/12': arrowNarrowDownOutlined12,
  'arrow-narrow-down/outlined/16': arrowNarrowDownOutlined16,
  'arrow-narrow-left/filled/16': arrowNarrowLeftFilled16,
  'arrow-narrow-left/outlined/16': arrowNarrowLeftOutlined16,
  'arrow-narrow-right/filled/12': arrowNarrowRightFilled12,
  'arrow-narrow-right/filled/16': arrowNarrowRightFilled16,
  'arrow-narrow-right/filled/20': arrowNarrowRightFilled20,
  'arrow-narrow-right/outlined/12': arrowNarrowRightOutlined12,
  'arrow-narrow-right/outlined/16': arrowNarrowRightOutlined16,
  'arrow-narrow-right/outlined/20': arrowNarrowRightOutlined20,
  'arrow-narrow-up-right/filled/20': arrowNarrowUpRightFilled20,
  'arrow-narrow-up-right/outlined/12': arrowNarrowUpRightOutlined12,
  'arrow-narrow-up-right/outlined/16': arrowNarrowUpRightOutlined16,
  'arrow-narrow-up-right/outlined/20': arrowNarrowUpRightOutlined20,
  'arrow-narrow-up/filled/16': arrowNarrowUpFilled16,
  'arrow-narrow-up/outlined/12': arrowNarrowUpOutlined12,
  'arrow-narrow-up/outlined/16': arrowNarrowUpOutlined16,
  'arrow-narrow-up/outlined/20': arrowNarrowUpOutlined20,
  'at-sign/filled/16': atSignFilled16,
  'at-sign/outlined/12': atSignOutlined12,
  'at-sign/outlined/16': atSignOutlined16,
  'at-sign/outlined/20': atSignOutlined20,
  'audit-log/filled/16': auditLogFilled16,
  'audit-log/outlined/12': auditLogOutlined12,
  'audit-log/outlined/16': auditLogOutlined16,
  'audit-log/outlined/20': auditLogOutlined20,
  'autopilot/filled/16': autopilotFilled16,
  'autopilot/filled/20': autopilotFilled20,
  'autopilot/outlined/12': autopilotOutlined12,
  'autopilot/outlined/16': autopilotOutlined16,
  'autopilot/outlined/20': autopilotOutlined20,
  'bar-chart-01/filled/16': barChart01Filled16,
  'bar-chart-01/filled/20': barChart01Filled20,
  'bar-chart-01/outlined/16': barChart01Outlined16,
  'bar-chart-01/outlined/20': barChart01Outlined20,
  'bar-chart-10/filled/16': barChart10Filled16,
  'bar-chart-10/outlined/16': barChart10Outlined16,
  'bar-chart-10/outlined/20': barChart10Outlined20,
  'beaker/filled/12': beakerFilled12,
  'beaker/filled/16': beakerFilled16,
  'beaker/filled/20': beakerFilled20,
  'beaker/outlined/12': beakerOutlined12,
  'beaker/outlined/16': beakerOutlined16,
  'beaker/outlined/20': beakerOutlined20,
  'bell-01/filled/12': bell01Filled12,
  'bell-01/filled/16': bell01Filled16,
  'bell-01/filled/20': bell01Filled20,
  'bell-01/outlined/12': bell01Outlined12,
  'bell-01/outlined/16': bell01Outlined16,
  'bell-01/outlined/20': bell01Outlined20,
  'bell-off-01/filled/16': bellOff01Filled16,
  'bell-off-01/filled/20': bellOff01Filled20,
  'bell-off-01/outlined/12': bellOff01Outlined12,
  'bell-off-01/outlined/16': bellOff01Outlined16,
  'bell-off-01/outlined/20': bellOff01Outlined20,
  'bold-01/outlined/16': bold01Outlined16,
  'bold-01/outlined/20': bold01Outlined20,
  'book-closed/outlined/16': bookClosedOutlined16,
  'book-closed/outlined/20': bookClosedOutlined20,
  'book-open-01/filled/16': bookOpen01Filled16,
  'book-open-01/filled/20': bookOpen01Filled20,
  'book-open-01/outlined/12': bookOpen01Outlined12,
  'book-open-01/outlined/16': bookOpen01Outlined16,
  'book-open-01/outlined/20': bookOpen01Outlined20,
  'brackets-ellipses/filled/16': bracketsEllipsesFilled16,
  'brackets-ellipses/filled/20': bracketsEllipsesFilled20,
  'brackets-ellipses/outlined/12': bracketsEllipsesOutlined12,
  'brackets-ellipses/outlined/16': bracketsEllipsesOutlined16,
  'brackets-ellipses/outlined/20': bracketsEllipsesOutlined20,
  'branching-rule/filled/16': branchingRuleFilled16,
  'branching-rule/filled/20': branchingRuleFilled20,
  'branching-rule/outlined/16': branchingRuleOutlined16,
  'briefcase-01-plus/outlined/16': briefcase01PlusOutlined16,
  'briefcase-01/filled/12': briefcase01Filled12,
  'briefcase-01/filled/16': briefcase01Filled16,
  'briefcase-01/filled/20': briefcase01Filled20,
  'briefcase-01/outlined/12': briefcase01Outlined12,
  'briefcase-01/outlined/16': briefcase01Outlined16,
  'briefcase-01/outlined/20': briefcase01Outlined20,
  'building-05/filled/16': building05Filled16,
  'building-05/filled/20': building05Filled20,
  'building-05/outlined/16': building05Outlined16,
  'building-05/outlined/20': building05Outlined20,
  'business-hours/filled/20': businessHoursFilled20,
  'business-hours/outlined/16': businessHoursOutlined16,
  'calendar-check-02/filled/16': calendarCheck02Filled16,
  'calendar-check-02/filled/20': calendarCheck02Filled20,
  'calendar-check-02/outlined/16': calendarCheck02Outlined16,
  'calendar-check-02/outlined/20': calendarCheck02Outlined20,
  'calendar-plus-02/outlined/20': calendarPlus02Outlined20,
  'calendar/filled/12': calendarFilled12,
  'calendar/filled/16': calendarFilled16,
  'calendar/filled/20': calendarFilled20,
  'calendar/outlined/12': calendarOutlined12,
  'calendar/outlined/16': calendarOutlined16,
  'calendar/outlined/20': calendarOutlined20,
  'caret-collapse/outlined/12': caretCollapseOutlined12,
  'caret-collapse/outlined/16': caretCollapseOutlined16,
  'caret-expand/outlined/12': caretExpandOutlined12,
  'caret-expand/outlined/16': caretExpandOutlined16,
  'chat-ended-activity/outlined/12': chatEndedActivityOutlined12,
  'chat/filled/12': chatFilled12,
  'chat/filled/16': chatFilled16,
  'chat/filled/20': chatFilled20,
  'chat/outlined/12': chatOutlined12,
  'chat/outlined/16': chatOutlined16,
  'chat/outlined/20': chatOutlined20,
  'check-circle/filled/12': checkCircleFilled12,
  'check-circle/filled/16': checkCircleFilled16,
  'check-circle/filled/20': checkCircleFilled20,
  'check-circle/outlined/12': checkCircleOutlined12,
  'check-circle/outlined/16': checkCircleOutlined16,
  'check-circle/outlined/20': checkCircleOutlined20,
  'check-verified-02/filled/16': checkVerified02Filled16,
  'check-verified-02/filled/20': checkVerified02Filled20,
  'check-verified-02/outlined/16': checkVerified02Outlined16,
  'check/outlined/12': checkOutlined12,
  'check/outlined/16': checkOutlined16,
  'check/outlined/20': checkOutlined20,
  'chevron-down/outlined/12': chevronDownOutlined12,
  'chevron-down/outlined/16': chevronDownOutlined16,
  'chevron-down/outlined/20': chevronDownOutlined20,
  'chevron-left/outlined/16': chevronLeftOutlined16,
  'chevron-left/outlined/20': chevronLeftOutlined20,
  'chevron-right/outlined/12': chevronRightOutlined12,
  'chevron-right/outlined/16': chevronRightOutlined16,
  'chevron-right/outlined/20': chevronRightOutlined20,
  'chevron-up/outlined/12': chevronUpOutlined12,
  'chevron-up/outlined/16': chevronUpOutlined16,
  'chevron-up/outlined/20': chevronUpOutlined20,
  'circle/filled/16': circleFilled16,
  'clock-check/outlined/16': clockCheckOutlined16,
  'clock-play/outlined/12': clockPlayOutlined12,
  'clock-play/outlined/16': clockPlayOutlined16,
  'clock-play/outlined/20': clockPlayOutlined20,
  'clock-play/outlined/24': clockPlayOutlined24,
  'clock-rewind/outlined/16': clockRewindOutlined16,
  'clock-rewind/outlined/20': clockRewindOutlined20,
  'clock-snooze/filled/16': clockSnoozeFilled16,
  'clock-snooze/outlined/16': clockSnoozeOutlined16,
  'clock-snooze/outlined/20': clockSnoozeOutlined20,
  'clock/filled/12': clockFilled12,
  'clock/filled/16': clockFilled16,
  'clock/filled/20': clockFilled20,
  'clock/outlined/12': clockOutlined12,
  'clock/outlined/16': clockOutlined16,
  'clock/outlined/20': clockOutlined20,
  'cloud-off/filled/16': cloudOffFilled16,
  'cloud-off/filled/20': cloudOffFilled20,
  'code-01/filled/16': code01Filled16,
  'code-01/outlined/12': code01Outlined12,
  'code-01/outlined/16': code01Outlined16,
  'code-01/outlined/20': code01Outlined20,
  'columns-03/filled/12': columns03Filled12,
  'columns-03/filled/16': columns03Filled16,
  'columns-03/filled/20': columns03Filled20,
  'columns-03/outlined/12': columns03Outlined12,
  'columns-03/outlined/16': columns03Outlined16,
  'columns-03/outlined/20': columns03Outlined20,
  'connectors/filled/12': connectorsFilled12,
  'connectors/filled/16': connectorsFilled16,
  'connectors/filled/20': connectorsFilled20,
  'connectors/outlined/12': connectorsOutlined12,
  'connectors/outlined/16': connectorsOutlined16,
  'connectors/outlined/20': connectorsOutlined20,
  'contact-auto/filled/12': contactAutoFilled12,
  'contact-auto/filled/16': contactAutoFilled16,
  'contact-auto/outlined/16': contactAutoOutlined16,
  'contrast-02/filled/12': contrast02Filled12,
  'contrast-02/outlined/12': contrast02Outlined12,
  'contrast-02/outlined/16': contrast02Outlined16,
  'contrast-02/outlined/20': contrast02Outlined20,
  'conversation-search/outlined/20': conversationSearchOutlined20,
  'conversation/outlined/12': conversationOutlined12,
  'conversation/outlined/16': conversationOutlined16,
  'copilot/filled/20': copilotFilled20,
  'copilot/outlined/16': copilotOutlined16,
  'copy-06/outlined/12': copy06Outlined12,
  'copy-06/outlined/16': copy06Outlined16,
  'copy-file/filled/16': copyFileFilled16,
  'copy-file/outlined/20': copyFileOutlined20,
  'corner-down-right/outlined/12': cornerDownRightOutlined12,
  'corner-down-right/outlined/16': cornerDownRightOutlined16,
  'corner-down-right/outlined/20': cornerDownRightOutlined20,
  'corner-up-left-double/outlined/16': cornerUpLeftDoubleOutlined16,
  'corner-up-left-double/outlined/20': cornerUpLeftDoubleOutlined20,
  'corner-up-left/filled/16': cornerUpLeftFilled16,
  'corner-up-left/filled/20': cornerUpLeftFilled20,
  'corner-up-left/outlined/12': cornerUpLeftOutlined12,
  'corner-up-left/outlined/16': cornerUpLeftOutlined16,
  'corner-up-left/outlined/20': cornerUpLeftOutlined20,
  'corner-up-right/filled/20': cornerUpRightFilled20,
  'corner-up-right/outlined/16': cornerUpRightOutlined16,
  'corner-up-right/outlined/20': cornerUpRightOutlined20,
  'cpu-chip-01/filled/16': cpuChip01Filled16,
  'credit-card-02/filled/16': creditCard02Filled16,
  'credit-card-02/filled/20': creditCard02Filled20,
  'credit-card-02/outlined/16': creditCard02Outlined16,
  'crown/filled/16': crownFilled16,
  'cube-01-off/outlined/12': cube01OffOutlined12,
  'cube-01-off/outlined/16': cube01OffOutlined16,
  'cube-01-off/outlined/20': cube01OffOutlined20,
  'cube-01/filled/16': cube01Filled16,
  'cube-01/filled/20': cube01Filled20,
  'cube-01/outlined/12': cube01Outlined12,
  'cube-01/outlined/16': cube01Outlined16,
  'cube-01/outlined/20': cube01Outlined20,
  'cube-outline/outlined/12': cubeOutlineOutlined12,
  'cursor-click/filled/16': cursorClickFilled16,
  'customer-portal/filled/12': customerPortalFilled12,
  'customer-portal/filled/16': customerPortalFilled16,
  'customer-portal/filled/20': customerPortalFilled20,
  'customer-portal/outlined/12': customerPortalOutlined12,
  'customer-portal/outlined/16': customerPortalOutlined16,
  'dataflow-02/filled/16': dataflow02Filled16,
  'dataflow-02/filled/20': dataflow02Filled20,
  'dataflow-02/outlined/16': dataflow02Outlined16,
  'dataflow-02/outlined/20': dataflow02Outlined20,
  'delete/outlined/20': deleteOutlined20,
  'deliverability/filled/16': deliverabilityFilled16,
  'deliverability/filled/20': deliverabilityFilled20,
  'deliverability/outlined/16': deliverabilityOutlined16,
  'diamond-01/filled/12': diamond01Filled12,
  'diamond-01/filled/16': diamond01Filled16,
  'diamond-01/outlined/16': diamond01Outlined16,
  'discussions/filled/12': discussionsFilled12,
  'discussions/filled/16': discussionsFilled16,
  'discussions/outlined/12': discussionsOutlined12,
  'discussions/outlined/16': discussionsOutlined16,
  'discussions/outlined/20': discussionsOutlined20,
  'distribute-spacing-vertical/filled/20': distributeSpacingVerticalFilled20,
  'distribute-spacing-vertical/outlined/20': distributeSpacingVerticalOutlined20,
  'divider/outlined/16': dividerOutlined16,
  'divider/outlined/20': dividerOutlined20,
  'donut-chart/outlined/16': donutChartOutlined16,
  'door-open/outlined/16': doorOpenOutlined16,
  'dotpoints-01/outlined/12': dotpoints01Outlined12,
  'dotpoints-01/outlined/16': dotpoints01Outlined16,
  'dotpoints-01/outlined/20': dotpoints01Outlined20,
  'dots-grid/filled/20': dotsGridFilled20,
  'dots-grid/outlined/20': dotsGridOutlined20,
  'dots-horizontal/outlined/16': dotsHorizontalOutlined16,
  'dots-horizontal/outlined/20': dotsHorizontalOutlined20,
  'dots-vertical/outlined/16': dotsVerticalOutlined16,
  'dots-vertical/outlined/20': dotsVerticalOutlined20,
  'download-02/filled/16': download02Filled16,
  'download-02/filled/20': download02Filled20,
  'download-02/outlined/12': download02Outlined12,
  'download-02/outlined/16': download02Outlined16,
  'download-02/outlined/20': download02Outlined20,
  'edit-01/filled/20': edit01Filled20,
  'edit-01/outlined/12': edit01Outlined12,
  'edit-01/outlined/16': edit01Outlined16,
  'edit-01/outlined/20': edit01Outlined20,
  'edit-05/filled/16': edit05Filled16,
  'edit-05/outlined/16': edit05Outlined16,
  'edit-05/outlined/20': edit05Outlined20,
  'emoji-activity/outlined/16': emojiActivityOutlined16,
  'emoji-food/outlined/20': emojiFoodOutlined20,
  'emoji-nature/outlined/20': emojiNatureOutlined20,
  'emoji-symbols/filled/16': emojiSymbolsFilled16,
  'emoji-symbols/outlined/16': emojiSymbolsOutlined16,
  'emoji-symbols/outlined/20': emojiSymbolsOutlined20,
  'expand-01/outlined/16': expand01Outlined16,
  'expand-01/outlined/20': expand01Outlined20,
  'export/outlined/16': exportOutlined16,
  'export/outlined/20': exportOutlined20,
  'eye-off/filled/16': eyeOffFilled16,
  'eye-off/outlined/16': eyeOffOutlined16,
  'eye/filled/12': eyeFilled12,
  'eye/filled/16': eyeFilled16,
  'eye/filled/20': eyeFilled20,
  'eye/outlined/12': eyeOutlined12,
  'eye/outlined/16': eyeOutlined16,
  'face-smile/outlined/16': faceSmileOutlined16,
  'face-smile/outlined/20': faceSmileOutlined20,
  'facebook/outlined/16': facebookOutlined16,
  'feather/filled/16': featherFilled16,
  'feather/filled/20': featherFilled20,
  'feather/outlined/16': featherOutlined16,
  'field-custom/filled/16': fieldCustomFilled16,
  'field-custom/filled/20': fieldCustomFilled20,
  'field-custom/outlined/12': fieldCustomOutlined12,
  'field-custom/outlined/16': fieldCustomOutlined16,
  'file-02/filled/16': file02Filled16,
  'file-02/filled/20': file02Filled20,
  'file-02/outlined/12': file02Outlined12,
  'file-02/outlined/16': file02Outlined16,
  'file-02/outlined/20': file02Outlined20,
  'file-05/filled/12': file05Filled12,
  'file-05/filled/16': file05Filled16,
  'file-05/filled/20': file05Filled20,
  'file-05/outlined/12': file05Outlined12,
  'file-05/outlined/16': file05Outlined16,
  'file-05/outlined/20': file05Outlined20,
  'file-check-02/filled/16': fileCheck02Filled16,
  'file-check-02/outlined/16': fileCheck02Outlined16,
  'file-download-03/outlined/16': fileDownload03Outlined16,
  'file-search-01/filled/16': fileSearch01Filled16,
  'filter-lines/filled/16': filterLinesFilled16,
  'filter-lines/outlined/12': filterLinesOutlined12,
  'filter-lines/outlined/16': filterLinesOutlined16,
  'filter-lines/outlined/20': filterLinesOutlined20,
  'first-page/filled/16': firstPageFilled16,
  'fix-grammar/outlined/12': fixGrammarOutlined12,
  'fix-grammar/outlined/16': fixGrammarOutlined16,
  'flag-01/outlined/16': flag01Outlined16,
  'flag-01/outlined/20': flag01Outlined20,
  'flip-backward/outlined/12': flipBackwardOutlined12,
  'flip-backward/outlined/16': flipBackwardOutlined16,
  'flip-forward-plus/outlined/16': flipForwardPlusOutlined16,
  'floating/outlined/16': floatingOutlined16,
  'floating/outlined/20': floatingOutlined20,
  'focus/outlined/20': focusOutlined20,
  'folder/filled/16': folderFilled16,
  'folder/filled/20': folderFilled20,
  'folder/outlined/16': folderOutlined16,
  'folder/outlined/20': folderOutlined20,
  'formatting-color/outlined/16': formattingColorOutlined16,
  'formatting-color/outlined/20': formattingColorOutlined20,
  'formatting-highlight/outlined/16': formattingHighlightOutlined16,
  'formatting-highlight/outlined/20': formattingHighlightOutlined20,
  'formatting-list/outlined/16': formattingListOutlined16,
  'formatting-quote/outlined/16': formattingQuoteOutlined16,
  'formatting-quote/outlined/20': formattingQuoteOutlined20,
  'formatting/outlined/16': formattingOutlined16,
  'formatting/outlined/20': formattingOutlined20,
  'forward-10s/filled/20': forward10SFilled20,
  'front-logo/filled/12': frontLogoFilled12,
  'geometry/filled/16': geometryFilled16,
  'geometry/outlined/16': geometryOutlined16,
  'gif/outlined/16': gifOutlined16,
  'gif/outlined/20': gifOutlined20,
  'gift-01/outlined/16': gift01Outlined16,
  'git-branch-01/filled/12': gitBranch01Filled12,
  'git-branch-01/filled/16': gitBranch01Filled16,
  'git-branch-01/filled/20': gitBranch01Filled20,
  'git-branch-01/outlined/12': gitBranch01Outlined12,
  'git-branch-01/outlined/16': gitBranch01Outlined16,
  'globe-01/filled/16': globe01Filled16,
  'globe-01/outlined/12': globe01Outlined12,
  'globe-01/outlined/16': globe01Outlined16,
  'globe-01/outlined/20': globe01Outlined20,
  'globe-04/filled/20': globe04Filled20,
  'go-to-conversation/outlined/20': goToConversationOutlined20,
  'google-play/filled/16': googlePlayFilled16,
  'google-play/outlined/16': googlePlayOutlined16,
  'grab-handle/outlined/16': grabHandleOutlined16,
  'graduation-hat-01/filled/16': graduationHat01Filled16,
  'graduation-hat-01/outlined/16': graduationHat01Outlined16,
  'graduation-hat-01/outlined/20': graduationHat01Outlined20,
  'grammar/outlined/16': grammarOutlined16,
  'grid-01/filled/12': grid01Filled12,
  'grid-01/filled/16': grid01Filled16,
  'grid-01/filled/20': grid01Filled20,
  'grid-01/outlined/12': grid01Outlined12,
  'grid-01/outlined/16': grid01Outlined16,
  'grid-01/outlined/20': grid01Outlined20,
  'heart/filled/20': heartFilled20,
  'heart/outlined/16': heartOutlined16,
  'heart/outlined/20': heartOutlined20,
  'help-center/filled/16': helpCenterFilled16,
  'help-center/filled/20': helpCenterFilled20,
  'help-center/outlined/16': helpCenterOutlined16,
  'help-circle/filled/12': helpCircleFilled12,
  'help-circle/filled/16': helpCircleFilled16,
  'help-circle/filled/20': helpCircleFilled20,
  'help-circle/outlined/12': helpCircleOutlined12,
  'help-circle/outlined/16': helpCircleOutlined16,
  'help-circle/outlined/20': helpCircleOutlined20,
  'home-05/filled/16': home05Filled16,
  'home-05/filled/20': home05Filled20,
  'home-05/outlined/16': home05Outlined16,
  'hourglass-check/filled/16': hourglassCheckFilled16,
  'hourglass-check/filled/20': hourglassCheckFilled20,
  'hourglass-check/outlined/16': hourglassCheckOutlined16,
  'hourglass-check/outlined/20': hourglassCheckOutlined20,
  'image-03/filled/16': image03Filled16,
  'image-03/outlined/20': image03Outlined20,
  'inbox-01/filled/12': inbox01Filled12,
  'inbox-01/filled/16': inbox01Filled16,
  'inbox-01/filled/20': inbox01Filled20,
  'inbox-01/outlined/12': inbox01Outlined12,
  'inbox-01/outlined/16': inbox01Outlined16,
  'inbox-01/outlined/20': inbox01Outlined20,
  'inbox-list/filled/12': inboxListFilled12,
  'inbox-list/filled/16': inboxListFilled16,
  'inbox-list/outlined/12': inboxListOutlined12,
  'inbox-list/outlined/16': inboxListOutlined16,
  'info-circle/filled/16': infoCircleFilled16,
  'info-circle/filled/20': infoCircleFilled20,
  'info-circle/outlined/16': infoCircleOutlined16,
  'info-circle/outlined/20': infoCircleOutlined20,
  'info-history/outlined/20': infoHistoryOutlined20,
  'intercom/outlined/16': intercomOutlined16,
  'italic-01/outlined/16': italic01Outlined16,
  'italic-01/outlined/20': italic01Outlined20,
  'key-metric/outlined/16': keyMetricOutlined16,
  'keyboard-02/filled/20': keyboard02Filled20,
  'laptop/outlined/16': laptopOutlined16,
  'last-page/outlined/16': lastPageOutlined16,
  'layers-three-01/filled/16': layersThree01Filled16,
  'layers-three-01/filled/20': layersThree01Filled20,
  'layers-three-01/outlined/12': layersThree01Outlined12,
  'layers-three-01/outlined/16': layersThree01Outlined16,
  'layout-alt-01/filled/16': layoutAlt01Filled16,
  'layout-alt-01/outlined/16': layoutAlt01Outlined16,
  'layout-alt-01/outlined/20': layoutAlt01Outlined20,
  'layout-grid-02/outlined/16': layoutGrid02Outlined16,
  'layout-left/outlined/12': layoutLeftOutlined12,
  'layout-left/outlined/16': layoutLeftOutlined16,
  'layout-left/outlined/20': layoutLeftOutlined20,
  'layout-right/outlined/16': layoutRightOutlined16,
  'layout-right/outlined/20': layoutRightOutlined20,
  'lightbulb-04/filled/12': lightbulb04Filled12,
  'lightbulb-04/filled/16': lightbulb04Filled16,
  'lightbulb-04/filled/20': lightbulb04Filled20,
  'lightbulb-04/filled/24': lightbulb04Filled24,
  'lightbulb-04/outlined/16': lightbulb04Outlined16,
  'lightbulb-04/outlined/20': lightbulb04Outlined20,
  'lightning-01/filled/12': lightning01Filled12,
  'lightning-01/filled/16': lightning01Filled16,
  'lightning-01/filled/20': lightning01Filled20,
  'lightning-01/outlined/12': lightning01Outlined12,
  'lightning-01/outlined/16': lightning01Outlined16,
  'lightning-01/outlined/20': lightning01Outlined20,
  'line-chart-up-01/outlined/16': lineChartUp01Outlined16,
  'linear-rule/filled/16': linearRuleFilled16,
  'linear-rule/filled/20': linearRuleFilled20,
  'linear-rule/outlined/16': linearRuleOutlined16,
  'link-03/outlined/12': link03Outlined12,
  'link-03/outlined/16': link03Outlined16,
  'link-03/outlined/20': link03Outlined20,
  'link-broken-03/filled/16': linkBroken03Filled16,
  'link-broken-03/filled/20': linkBroken03Filled20,
  'link-broken-03/outlined/12': linkBroken03Outlined12,
  'link-broken-03/outlined/16': linkBroken03Outlined16,
  'link-broken-03/outlined/20': linkBroken03Outlined20,
  'link-external-02/outlined/16': linkExternal02Outlined16,
  'link-to/filled/16': linkToFilled16,
  'link-to/outlined/16': linkToOutlined16,
  'lock-01/filled/12': lock01Filled12,
  'lock-01/filled/16': lock01Filled16,
  'lock-01/filled/20': lock01Filled20,
  'lock-01/outlined/16': lock01Outlined16,
  'lock-01/outlined/20': lock01Outlined20,
  'lock-unlocked-01/outlined/16': lockUnlocked01Outlined16,
  'log-out-02/outlined/16': logOut02Outlined16,
  'longer/outlined/12': longerOutlined12,
  'longer/outlined/16': longerOutlined16,
  'mail-01/filled/12': mail01Filled12,
  'mail-01/filled/16': mail01Filled16,
  'mail-01/filled/20': mail01Filled20,
  'mail-01/outlined/12': mail01Outlined12,
  'mail-01/outlined/16': mail01Outlined16,
  'mail-01/outlined/20': mail01Outlined20,
  'mail-04/outlined/16': mail04Outlined16,
  'mail-notification/outlined/16': mailNotificationOutlined16,
  'marker-pin-01/outlined/16': markerPin01Outlined16,
  'menu-01/outlined/20': menu01Outlined20,
  'merge/filled/12': mergeFilled12,
  'merge/filled/16': mergeFilled16,
  'merge/outlined/12': mergeOutlined12,
  'merge/outlined/16': mergeOutlined16,
  'merge/outlined/20': mergeOutlined20,
  'message-square-01/filled/20': messageSquare01Filled20,
  'message-square-01/outlined/12': messageSquare01Outlined12,
  'message-square-01/outlined/16': messageSquare01Outlined16,
  'message-square-01/outlined/20': messageSquare01Outlined20,
  'message-template/filled/12': messageTemplateFilled12,
  'message-template/filled/16': messageTemplateFilled16,
  'message-template/filled/20': messageTemplateFilled20,
  'message-template/outlined/12': messageTemplateOutlined12,
  'message-template/outlined/16': messageTemplateOutlined16,
  'message-template/outlined/20': messageTemplateOutlined20,
  'message-text-circle-02/filled/16': messageTextCircle02Filled16,
  'message-text-circle-02/filled/20': messageTextCircle02Filled20,
  'message-text-circle-02/outlined/20': messageTextCircle02Outlined20,
  'microphone-01/outlined/16': microphone01Outlined16,
  'minimize-01/outlined/16': minimize01Outlined16,
  'minimize-01/outlined/20': minimize01Outlined20,
  'minus-circle/filled/12': minusCircleFilled12,
  'minus-circle/filled/16': minusCircleFilled16,
  'minus-circle/outlined/12': minusCircleOutlined12,
  'minus-circle/outlined/16': minusCircleOutlined16,
  'minus/outlined/16': minusOutlined16,
  'minus/outlined/20': minusOutlined20,
  'moon-02/filled/16': moon02Filled16,
  'moon-02/outlined/16': moon02Outlined16,
  'muted-status/filled/12': mutedStatusFilled12,
  'numbers/outlined/12': numbersOutlined12,
  'numbers/outlined/16': numbersOutlined16,
  'numbers/outlined/20': numbersOutlined20,
  'open/filled/16': openFilled16,
  'outbox/filled/16': outboxFilled16,
  'outbox/filled/20': outboxFilled20,
  'outbox/outlined/16': outboxOutlined16,
  'paperclip/outlined/12': paperclipOutlined12,
  'paperclip/outlined/16': paperclipOutlined16,
  'paperclip/outlined/20': paperclipOutlined20,
  'paragraph-spacing/outlined/16': paragraphSpacingOutlined16,
  'pause-circle/filled/20': pauseCircleFilled20,
  'pause-circle/outlined/16': pauseCircleOutlined16,
  'pause-circle/outlined/20': pauseCircleOutlined20,
  'pause/filled/20': pauseFilled20,
  'person-speaking/outlined/16': personSpeakingOutlined16,
  'phone-call-01/filled/16': phoneCall01Filled16,
  'phone-call-01/filled/20': phoneCall01Filled20,
  'phone-call-01/outlined/12': phoneCall01Outlined12,
  'phone-call-01/outlined/16': phoneCall01Outlined16,
  'phone-call-01/outlined/20': phoneCall01Outlined20,
  'phone-hang-up/outlined/12': phoneHangUpOutlined12,
  'phone-hang-up/outlined/20': phoneHangUpOutlined20,
  'phone-incoming-01/filled/16': phoneIncoming01Filled16,
  'phone-incoming-01/outlined/12': phoneIncoming01Outlined12,
  'phone-outgoing-01/filled/16': phoneOutgoing01Filled16,
  'phone-outgoing-02/outlined/12': phoneOutgoing02Outlined12,
  'phone-pause/outlined/12': phonePauseOutlined12,
  'phone-x/filled/16': phoneXFilled16,
  'phone-x/outlined/12': phoneXOutlined12,
  'phone/filled/20': phoneFilled20,
  'phone/outlined/12': phoneOutlined12,
  'phone/outlined/16': phoneOutlined16,
  'phone/outlined/20': phoneOutlined20,
  'pie-chart-01/outlined/16': pieChart01Outlined16,
  'pin-02/filled/12': pin02Filled12,
  'pin-02/filled/16': pin02Filled16,
  'pin-02/outlined/16': pin02Outlined16,
  'pin-to-bottom/outlined/16': pinToBottomOutlined16,
  'pin-to-right/outlined/16': pinToRightOutlined16,
  'pin-to-right/outlined/20': pinToRightOutlined20,
  'plan-template/filled/12': planTemplateFilled12,
  'plan-template/filled/16': planTemplateFilled16,
  'plan-template/filled/20': planTemplateFilled20,
  'plan-template/filled/24': planTemplateFilled24,
  'plan-template/outlined/12': planTemplateOutlined12,
  'plan-template/outlined/16': planTemplateOutlined16,
  'plan-template/outlined/20': planTemplateOutlined20,
  'plan-template/outlined/24': planTemplateOutlined24,
  'plane/outlined/20': planeOutlined20,
  'play-circle/outlined/16': playCircleOutlined16,
  'play/filled/20': playFilled20,
  'play/outlined/12': playOutlined12,
  'play/outlined/16': playOutlined16,
  'playbook-temporary/filled/12': playbookTemporaryFilled12,
  'playbook-temporary/filled/16': playbookTemporaryFilled16,
  'playbook-temporary/filled/20': playbookTemporaryFilled20,
  'playbook-temporary/filled/24': playbookTemporaryFilled24,
  'playbook-temporary/outlined/12': playbookTemporaryOutlined12,
  'playbook-temporary/outlined/16': playbookTemporaryOutlined16,
  'playbook-temporary/outlined/20': playbookTemporaryOutlined20,
  'plus-circle/filled/16': plusCircleFilled16,
  'plus-circle/outlined/16': plusCircleOutlined16,
  'plus-circle/outlined/20': plusCircleOutlined20,
  'plus/outlined/12': plusOutlined12,
  'plus/outlined/16': plusOutlined16,
  'plus/outlined/20': plusOutlined20,
  'popin/outlined/20': popinOutlined20,
  'printer/outlined/16': printerOutlined16,
  'puzzle-piece/outlined/16': puzzlePieceOutlined16,
  'q-a-smart/filled/16': qASmartFilled16,
  'q-a-smart/filled/20': qASmartFilled20,
  'q-a-smart/outlined/16': qASmartOutlined16,
  'refresh-cw-01/filled/16': refreshCw01Filled16,
  'refresh-cw-01/filled/20': refreshCw01Filled20,
  'refresh-cw-01/outlined/12': refreshCw01Outlined12,
  'refresh-cw-01/outlined/16': refreshCw01Outlined16,
  'refresh-cw-01/outlined/20': refreshCw01Outlined20,
  'refresh-cw-02/outlined/16': refreshCw02Outlined16,
  'refresh-cw-02/outlined/20': refreshCw02Outlined20,
  'repeat-01/outlined/16': repeat01Outlined16,
  'repeat-01/outlined/20': repeat01Outlined20,
  'repeat-02/outlined/16': repeat02Outlined16,
  'replace-all/outlined/16': replaceAllOutlined16,
  'rewind-10s/filled/20': rewind10SFilled20,
  'rocket-02/filled/16': rocket02Filled16,
  'rocket-02/filled/20': rocket02Filled20,
  'rule-tester/outlined/16': ruleTesterOutlined16,
  'rule-tester/outlined/20': ruleTesterOutlined20,
  'save/outlined/20': saveOutlined20,
  'schedule/filled/16': scheduleFilled16,
  'schedule/outlined/16': scheduleOutlined16,
  'schedule/outlined/20': scheduleOutlined20,
  'search-sm/outlined/12': searchSmOutlined12,
  'search-sm/outlined/16': searchSmOutlined16,
  'search-sm/outlined/20': searchSmOutlined20,
  'send-04/outlined/16': send04Outlined16,
  'send/filled/16': sendFilled16,
  'send/filled/20': sendFilled20,
  'send/outlined/12': sendOutlined12,
  'send/outlined/16': sendOutlined16,
  'send/outlined/20': sendOutlined20,
  'settings-02/filled/12': settings02Filled12,
  'settings-02/filled/16': settings02Filled16,
  'settings-02/filled/20': settings02Filled20,
  'settings-02/outlined/12': settings02Outlined12,
  'settings-02/outlined/16': settings02Outlined16,
  'settings-02/outlined/20': settings02Outlined20,
  'settings-03/filled/12': settings03Filled12,
  'settings-03/filled/16': settings03Filled16,
  'settings-03/filled/20': settings03Filled20,
  'settings-03/outlined/12': settings03Outlined12,
  'settings-03/outlined/16': settings03Outlined16,
  'settings-03/outlined/20': settings03Outlined20,
  'shield/filled/20': shieldFilled20,
  'shift/filled/16': shiftFilled16,
  'shift/outlined/16': shiftOutlined16,
  'shorter/outlined/12': shorterOutlined12,
  'shorter/outlined/16': shorterOutlined16,
  'sidebar/filled/16': sidebarFilled16,
  'sidebar/outlined/16': sidebarOutlined16,
  'sidebar/outlined/20': sidebarOutlined20,
  'slack/filled/16': slackFilled16,
  'slash-circle-01/outlined/16': slashCircle01Outlined16,
  'slash-circle-01/outlined/20': slashCircle01Outlined20,
  'sliders-04/filled/16': sliders04Filled16,
  'sliders-04/outlined/16': sliders04Outlined16,
  'smart-products/filled/12': smartProductsFilled12,
  'smart-products/filled/16': smartProductsFilled16,
  'smart-products/filled/20': smartProductsFilled20,
  'smart-products/filled/24': smartProductsFilled24,
  'smart-products/outlined/12': smartProductsOutlined12,
  'smart-products/outlined/16': smartProductsOutlined16,
  'smart-products/outlined/20': smartProductsOutlined20,
  'smart-products/outlined/24': smartProductsOutlined24,
  'split/filled/12': splitFilled12,
  'split/filled/16': splitFilled16,
  'split/outlined/12': splitOutlined12,
  'split/outlined/16': splitOutlined16,
  'square/filled/12': squareFilled12,
  'square/filled/16': squareFilled16,
  'square/filled/20': squareFilled20,
  'stacked-bar/outlined/16': stackedBarOutlined16,
  'star-01/filled/12': star01Filled12,
  'star-01/filled/16': star01Filled16,
  'star-01/filled/20': star01Filled20,
  'star-01/outlined/16': star01Outlined16,
  'star-01/outlined/20': star01Outlined20,
  'star-04/filled/12': star04Filled12,
  'star-04/filled/16': star04Filled16,
  'star-04/filled/20': star04Filled20,
  'star-04/outlined/16': star04Outlined16,
  'star-04/outlined/20': star04Outlined20,
  'stars-01/filled/12': stars01Filled12,
  'status-change/filled/16': statusChangeFilled16,
  'status-change/filled/20': statusChangeFilled20,
  'status-change/outlined/16': statusChangeOutlined16,
  'status-change/outlined/20': statusChangeOutlined20,
  'sticker-square/outlined/12': stickerSquareOutlined12,
  'sticker-square/outlined/16': stickerSquareOutlined16,
  'strikethrough-01/outlined/16': strikethrough01Outlined16,
  'strikethrough-01/outlined/20': strikethrough01Outlined20,
  'sun/outlined/16': sunOutlined16,
  'switch-horizontal-01/filled/16': switchHorizontal01Filled16,
  'switch-horizontal-01/outlined/12': switchHorizontal01Outlined12,
  'switch-horizontal-01/outlined/20': switchHorizontal01Outlined20,
  'switch-vertical-01/outlined/16': switchVertical01Outlined16,
  'table-column/outlined/16': tableColumnOutlined16,
  'table-column/outlined/20': tableColumnOutlined20,
  'table/filled/16': tableFilled16,
  'table/filled/20': tableFilled20,
  'table/outlined/16': tableOutlined16,
  'table/outlined/20': tableOutlined20,
  'tag-01/filled/12': tag01Filled12,
  'tag-01/filled/16': tag01Filled16,
  'tag-01/filled/20': tag01Filled20,
  'tag-01/outlined/12': tag01Outlined12,
  'tag-01/outlined/16': tag01Outlined16,
  'tag-01/outlined/20': tag01Outlined20,
  'tag-03/filled/12': tag03Filled12,
  'tag-03/filled/16': tag03Filled16,
  'tag-03/outlined/12': tag03Outlined12,
  'tag-03/outlined/16': tag03Outlined16,
  'tag-03/outlined/20': tag03Outlined20,
  'tag-04/filled/12': tag04Filled12,
  'tag-04/filled/16': tag04Filled16,
  'tag-04/filled/20': tag04Filled20,
  'tag-04/outlined/12': tag04Outlined12,
  'tag-04/outlined/16': tag04Outlined16,
  'target-03/filled/12': target03Filled12,
  'target-03/filled/16': target03Filled16,
  'target-03/outlined/12': target03Outlined12,
  'target-03/outlined/16': target03Outlined16,
  'target-off/outlined/16': targetOffOutlined16,
  'target-stroke-03/outlined/16': targetStroke03Outlined16,
  'task-02/filled/12': task02Filled12,
  'task-02/filled/16': task02Filled16,
  'task-02/filled/20': task02Filled20,
  'task-02/filled/24': task02Filled24,
  'task-02/outlined/12': task02Outlined12,
  'task-02/outlined/16': task02Outlined16,
  'task-02/outlined/20': task02Outlined20,
  'task-02/outlined/24': task02Outlined24,
  'task-template/filled/12': taskTemplateFilled12,
  'task-template/filled/16': taskTemplateFilled16,
  'task-template/filled/20': taskTemplateFilled20,
  'task-template/filled/24': taskTemplateFilled24,
  'task-template/outlined/12': taskTemplateOutlined12,
  'task-template/outlined/16': taskTemplateOutlined16,
  'task-template/outlined/20': taskTemplateOutlined20,
  'task-template/outlined/24': taskTemplateOutlined24,
  'task/filled/12': taskFilled12,
  'task/filled/16': taskFilled16,
  'task/filled/20': taskFilled20,
  'task/outlined/12': taskOutlined12,
  'task/outlined/16': taskOutlined16,
  'task/outlined/20': taskOutlined20,
  'template/filled/12': templateFilled12,
  'template/filled/16': templateFilled16,
  'template/filled/20': templateFilled20,
  'template/filled/24': templateFilled24,
  'template/outlined/12': templateOutlined12,
  'template/outlined/16': templateOutlined16,
  'template/outlined/20': templateOutlined20,
  'template/outlined/24': templateOutlined24,
  'thumbs-down/filled/16': thumbsDownFilled16,
  'thumbs-down/filled/20': thumbsDownFilled20,
  'thumbs-down/outlined/16': thumbsDownOutlined16,
  'thumbs-down/outlined/20': thumbsDownOutlined20,
  'thumbs-up/filled/16': thumbsUpFilled16,
  'thumbs-up/filled/20': thumbsUpFilled20,
  'thumbs-up/outlined/16': thumbsUpOutlined16,
  'thumbs-up/outlined/20': thumbsUpOutlined20,
  'ticket-01/filled/12': ticket01Filled12,
  'ticket-01/filled/16': ticket01Filled16,
  'ticket-01/outlined/12': ticket01Outlined12,
  'ticket-01/outlined/16': ticket01Outlined16,
  'tool/filled/20': toolFilled20,
  'tool/outlined/16': toolOutlined16,
  'tool/outlined/20': toolOutlined20,
  'translate-01/outlined/12': translate01Outlined12,
  'translate-01/outlined/16': translate01Outlined16,
  'trash-03/filled/16': trash03Filled16,
  'trash-03/filled/20': trash03Filled20,
  'trash-03/outlined/12': trash03Outlined12,
  'trash-03/outlined/16': trash03Outlined16,
  'trash-03/outlined/20': trash03Outlined20,
  'truck-01/filled/20': truck01Filled20,
  'twitter-x/filled/16': twitterXFilled16,
  'twitter-x/filled/20': twitterXFilled20,
  'twitter-x/outlined/16': twitterXOutlined16,
  'type-strikethrough-01/outlined/16': typeStrikethrough01Outlined16,
  'type-strikethrough-01/outlined/20': typeStrikethrough01Outlined20,
  'unassigned/filled/16': unassignedFilled16,
  'unassigned/outlined/16': unassignedOutlined16,
  'underline-01/outlined/16': underline01Outlined16,
  'underline-01/outlined/20': underline01Outlined20,
  'unpin/outlined/16': unpinOutlined16,
  'user-01/filled/12': user01Filled12,
  'user-01/filled/16': user01Filled16,
  'user-01/filled/20': user01Filled20,
  'user-01/outlined/12': user01Outlined12,
  'user-01/outlined/16': user01Outlined16,
  'user-01/outlined/20': user01Outlined20,
  'user-check-01/filled/16': userCheck01Filled16,
  'user-check-01/outlined/16': userCheck01Outlined16,
  'user-check-01/outlined/20': userCheck01Outlined20,
  'user-circle/filled/16': userCircleFilled16,
  'user-circle/filled/20': userCircleFilled20,
  'user-circle/outlined/12': userCircleOutlined12,
  'user-circle/outlined/16': userCircleOutlined16,
  'user-circle/outlined/20': userCircleOutlined20,
  'user-edit/filled/16': userEditFilled16,
  'user-edit/filled/20': userEditFilled20,
  'user-left-01/filled/12': userLeft01Filled12,
  'user-left-01/filled/16': userLeft01Filled16,
  'user-left-01/filled/20': userLeft01Filled20,
  'user-left-01/outlined/12': userLeft01Outlined12,
  'user-left-01/outlined/16': userLeft01Outlined16,
  'user-left-01/outlined/20': userLeft01Outlined20,
  'user-plus-01/outlined/12': userPlus01Outlined12,
  'user-plus-01/outlined/16': userPlus01Outlined16,
  'user-plus-01/outlined/20': userPlus01Outlined20,
  'user-right-01/filled/12': userRight01Filled12,
  'user-right-01/filled/16': userRight01Filled16,
  'user-right-01/filled/20': userRight01Filled20,
  'user-right-01/outlined/12': userRight01Outlined12,
  'user-right-01/outlined/16': userRight01Outlined16,
  'user-right-off/filled/12': userRightOffFilled12,
  'user-right-off/filled/20': userRightOffFilled20,
  'user-right-off/outlined/16': userRightOffOutlined16,
  'user-sparkle-01/filled/16': userSparkle01Filled16,
  'user-square/filled/12': userSquareFilled12,
  'user-square/filled/16': userSquareFilled16,
  'user-square/filled/20': userSquareFilled20,
  'user-square/outlined/12': userSquareOutlined12,
  'user-square/outlined/16': userSquareOutlined16,
  'user-square/outlined/20': userSquareOutlined20,
  'user-x-01/filled/16': userX01Filled16,
  'user-x-01/filled/20': userX01Filled20,
  'user-x-01/outlined/12': userX01Outlined12,
  'user-x-01/outlined/16': userX01Outlined16,
  'users-01/filled/12': users01Filled12,
  'users-01/filled/16': users01Filled16,
  'users-01/filled/20': users01Filled20,
  'users-01/outlined/12': users01Outlined12,
  'users-01/outlined/16': users01Outlined16,
  'users-01/outlined/20': users01Outlined20,
  'users-left/outlined/20': usersLeftOutlined20,
  'users-plus/outlined/16': usersPlusOutlined16,
  'users-sparkle/filled/24': usersSparkleFilled24,
  'users-sparkle/outlined/16': usersSparkleOutlined16,
  'users/filled/16': usersFilled16,
  'users/filled/20': usersFilled20,
  'users/outlined/16': usersOutlined16,
  'variable/outlined/12': variableOutlined12,
  'variable/outlined/16': variableOutlined16,
  'variable/outlined/20': variableOutlined20,
  'video-recorder/outlined/16': videoRecorderOutlined16,
  'video-recorder/outlined/20': videoRecorderOutlined20,
  'views/filled/12': viewsFilled12,
  'views/filled/16': viewsFilled16,
  'views/filled/20': viewsFilled20,
  'views/outlined/12': viewsOutlined12,
  'views/outlined/16': viewsOutlined16,
  'views/outlined/20': viewsOutlined20,
  'visitor-source/outlined/16': visitorSourceOutlined16,
  'visitor-source/outlined/20': visitorSourceOutlined20,
  'voicemail/filled/16': voicemailFilled16,
  'volume-max/filled/20': volumeMaxFilled20,
  'whatsapp/outlined/16': whatsappOutlined16,
  'whatsapp/outlined/20': whatsappOutlined20,
  'windows-close/outlined/20': windowsCloseOutlined20,
  'windows-maximize/outlined/20': windowsMaximizeOutlined20,
  'windows-minimize/outlined/20': windowsMinimizeOutlined20,
  'windows-unmaximize/outlined/20': windowsUnmaximizeOutlined20,
  'workspace/filled/16': workspaceFilled16,
  'workspace/outlined/16': workspaceOutlined16,
  'x-circle/filled/12': xCircleFilled12,
  'x-circle/filled/16': xCircleFilled16,
  'x-circle/filled/20': xCircleFilled20,
  'x-circle/outlined/12': xCircleOutlined12,
  'x-circle/outlined/16': xCircleOutlined16,
  'x-close/outlined/12': xCloseOutlined12,
  'x-close/outlined/16': xCloseOutlined16,
  'x-close/outlined/20': xCloseOutlined20,
});
